// @generated by protoc-gen-es v1.10.1 with parameter "target=ts,import_extension=none"
// @generated from file mono/ryugu/v1/contract_model.proto (package mono.ryugu.v1, syntax proto3)
/* eslint-disable */ // @ts-nocheck
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
import { Message, proto3, protoInt64 } from "@bufbuild/protobuf";
import { AddGlossaryRelationRequest as AddGlossaryRelationRequest$1, AddGlossaryRelationResponse as AddGlossaryRelationResponse$1, AddOccurrenceRequest as AddOccurrenceRequest$1, AddOccurrenceResponse as AddOccurrenceResponse$1, AddWorkstreamMemberRequest as AddWorkstreamMemberRequest$1, AddWorkstreamMemberResponse as AddWorkstreamMemberResponse$1, ApplyEvidenceBatchRequest as ApplyEvidenceBatchRequest$1, ApplyEvidenceBatchResponse as ApplyEvidenceBatchResponse$1, ApproveOccurrenceDecisionRequest as ApproveOccurrenceDecisionRequest$1, ApproveOccurrenceDecisionResponse as ApproveOccurrenceDecisionResponse$1, AssessWorkProductsRequest as AssessWorkProductsRequest$1, AssessWorkProductsResponse as AssessWorkProductsResponse$1, BindGlossaryTermRequest as BindGlossaryTermRequest$1, BindGlossaryTermResponse as BindGlossaryTermResponse$1, CreateCommentRequest as CreateCommentRequest$1, CreateCommentResponse as CreateCommentResponse$1, CreateDutyRequest as CreateDutyRequest$1, CreateDutyResponse as CreateDutyResponse$1, CreateScheduleRuleRequest as CreateScheduleRuleRequest$1, CreateScheduleRuleResponse as CreateScheduleRuleResponse$1, CreateSowRequest as CreateSowRequest$1, CreateSowResponse as CreateSowResponse$1, CreateSubmissionRequest as CreateSubmissionRequest$1, CreateSubmissionResponse as CreateSubmissionResponse$1, CreateWorkProductRequest as CreateWorkProductRequest$1, CreateWorkProductResponse as CreateWorkProductResponse$1, CreateWorkstreamRequest as CreateWorkstreamRequest$1, CreateWorkstreamResponse as CreateWorkstreamResponse$1, DeleteCommentRequest as DeleteCommentRequest$1, DeleteCommentResponse as DeleteCommentResponse$1, DeleteDutyRequest as DeleteDutyRequest$1, DeleteDutyResponse as DeleteDutyResponse$1, DeleteSavedViewRequest as DeleteSavedViewRequest$1, DeleteSavedViewResponse as DeleteSavedViewResponse$1, DeleteScheduleRuleRequest as DeleteScheduleRuleRequest$1, DeleteScheduleRuleResponse as DeleteScheduleRuleResponse$1, FacetOption, FindWorkProductDuplicatesRequest as FindWorkProductDuplicatesRequest$1, FindWorkProductDuplicatesResponse as FindWorkProductDuplicatesResponse$1, GetDeliverableSettingsRequest as GetDeliverableSettingsRequest$1, GetDeliverableSettingsResponse as GetDeliverableSettingsResponse$1, GetDutyRequest as GetDutyRequest$1, GetDutyResponse as GetDutyResponse$1, GetOccurrenceRequest as GetOccurrenceRequest$1, GetOccurrenceResponse as GetOccurrenceResponse$1, GetPortfolioDeliverySummaryRequest as GetPortfolioDeliverySummaryRequest$1, GetPortfolioDeliverySummaryResponse as GetPortfolioDeliverySummaryResponse$1, GetProgramGlossaryRequest as GetProgramGlossaryRequest$1, GetProgramGlossaryResponse as GetProgramGlossaryResponse$1, GetWorkstreamRequest as GetWorkstreamRequest$1, GetWorkstreamResponse as GetWorkstreamResponse$1, ImportTrackerRequest as ImportTrackerRequest$1, ImportTrackerResponse as ImportTrackerResponse$1, KpiReading, LinkWorkstreamLineageRequest as LinkWorkstreamLineageRequest$1, LinkWorkstreamLineageResponse as LinkWorkstreamLineageResponse$1, ListAttentionItemsRequest as ListAttentionItemsRequest$1, ListAttentionItemsResponse as ListAttentionItemsResponse$1, ListCommentsRequest as ListCommentsRequest$1, ListCommentsResponse as ListCommentsResponse$1, ListDutiesRequest as ListDutiesRequest$1, ListDutiesResponse as ListDutiesResponse$1, ListOccurrenceDecisionsRequest as ListOccurrenceDecisionsRequest$1, ListOccurrenceDecisionsResponse as ListOccurrenceDecisionsResponse$1, ListOccurrencesRequest as ListOccurrencesRequest$1, ListOccurrencesResponse as ListOccurrencesResponse$1, ListPortfolioOccurrencesRequest as ListPortfolioOccurrencesRequest$1, ListPortfolioOccurrencesResponse as ListPortfolioOccurrencesResponse$1, ListProgramSubmissionsRequest as ListProgramSubmissionsRequest$1, ListProgramSubmissionsResponse as ListProgramSubmissionsResponse$1, ListSavedViewsRequest as ListSavedViewsRequest$1, ListSavedViewsResponse as ListSavedViewsResponse$1, ListWorkProductsRequest as ListWorkProductsRequest$1, ListWorkProductsResponse as ListWorkProductsResponse$1, ListWorkstreamMembersRequest as ListWorkstreamMembersRequest$1, ListWorkstreamMembersResponse as ListWorkstreamMembersResponse$1, ListWorkstreamsRequest as ListWorkstreamsRequest$1, ListWorkstreamsResponse as ListWorkstreamsResponse$1, ListWorkstreamWindowCountsRequest as ListWorkstreamWindowCountsRequest$1, ListWorkstreamWindowCountsResponse as ListWorkstreamWindowCountsResponse$1, LogContractEventRequest as LogContractEventRequest$1, LogContractEventResponse as LogContractEventResponse$1, MoveOccurrenceRequest as MoveOccurrenceRequest$1, MoveOccurrenceResponse as MoveOccurrenceResponse$1, PortfolioAttentionItem, PromoteWorkProductRequest as PromoteWorkProductRequest$1, PromoteWorkProductResponse as PromoteWorkProductResponse$1, ProposeExtensionEvidenceRequest as ProposeExtensionEvidenceRequest$1, ProposeExtensionEvidenceResponse as ProposeExtensionEvidenceResponse$1, ProposeOccurrenceExtensionRequest as ProposeOccurrenceExtensionRequest$1, ProposeOccurrenceExtensionResponse as ProposeOccurrenceExtensionResponse$1, ProposeOccurrenceNotOwedRequest as ProposeOccurrenceNotOwedRequest$1, ProposeOccurrenceNotOwedResponse as ProposeOccurrenceNotOwedResponse$1, ProposeOccurrenceWaiverRequest as ProposeOccurrenceWaiverRequest$1, ProposeOccurrenceWaiverResponse as ProposeOccurrenceWaiverResponse$1, ProposeSubmissionEditRequest as ProposeSubmissionEditRequest$1, ProposeSubmissionEditResponse as ProposeSubmissionEditResponse$1, ProposeSubmissionEvidenceRequest as ProposeSubmissionEvidenceRequest$1, ProposeSubmissionEvidenceResponse as ProposeSubmissionEvidenceResponse$1, ProposeWaiverEditRequest as ProposeWaiverEditRequest$1, ProposeWaiverEditResponse as ProposeWaiverEditResponse$1, ProposeWaiverEvidenceRequest as ProposeWaiverEvidenceRequest$1, ProposeWaiverEvidenceResponse as ProposeWaiverEvidenceResponse$1, RecordOccurrenceDecisionCorAnswerRequest as RecordOccurrenceDecisionCorAnswerRequest$1, RecordOccurrenceDecisionCorAnswerResponse as RecordOccurrenceDecisionCorAnswerResponse$1, RecordReviewRequest as RecordReviewRequest$1, RecordReviewResponse as RecordReviewResponse$1, RejectGlossaryRelationRequest as RejectGlossaryRelationRequest$1, RejectGlossaryRelationResponse as RejectGlossaryRelationResponse$1, RejectGlossaryTermRequest as RejectGlossaryTermRequest$1, RejectGlossaryTermResponse as RejectGlossaryTermResponse$1, RejectOccurrenceDecisionRequest as RejectOccurrenceDecisionRequest$1, RejectOccurrenceDecisionResponse as RejectOccurrenceDecisionResponse$1, RekindGlossaryTermRequest as RekindGlossaryTermRequest$1, RekindGlossaryTermResponse as RekindGlossaryTermResponse$1, RemindOccurrenceRequest as RemindOccurrenceRequest$1, RemindOccurrenceResponse as RemindOccurrenceResponse$1, RemoveOccurrenceRequest as RemoveOccurrenceRequest$1, RemoveOccurrenceResponse as RemoveOccurrenceResponse$1, RemoveWorkstreamMemberRequest as RemoveWorkstreamMemberRequest$1, RemoveWorkstreamMemberResponse as RemoveWorkstreamMemberResponse$1, RuleSowGapRequest as RuleSowGapRequest$1, RuleSowGapResponse as RuleSowGapResponse$1, SaveViewRequest as SaveViewRequest$1, SaveViewResponse as SaveViewResponse$1, SetCommentUpvoteRequest as SetCommentUpvoteRequest$1, SetCommentUpvoteResponse as SetCommentUpvoteResponse$1, SetDutyAssignmentRequest as SetDutyAssignmentRequest$1, SetDutyAssignmentResponse as SetDutyAssignmentResponse$1, SetExerciseWorkstreamRequest as SetExerciseWorkstreamRequest$1, SetExerciseWorkstreamResponse as SetExerciseWorkstreamResponse$1, UpdateCommentRequest as UpdateCommentRequest$1, UpdateCommentResponse as UpdateCommentResponse$1, UpdateDeliverableSettingsRequest as UpdateDeliverableSettingsRequest$1, UpdateDeliverableSettingsResponse as UpdateDeliverableSettingsResponse$1, UpdateDutyRequest as UpdateDutyRequest$1, UpdateDutyResponse as UpdateDutyResponse$1, UpdateScheduleRuleRequest as UpdateScheduleRuleRequest$1, UpdateScheduleRuleResponse as UpdateScheduleRuleResponse$1, UpdateSubmissionRequest as UpdateSubmissionRequest$1, UpdateSubmissionResponse as UpdateSubmissionResponse$1, UpdateWorkProductRequest as UpdateWorkProductRequest$1, UpdateWorkProductResponse as UpdateWorkProductResponse$1, UpdateWorkstreamMemberRequest as UpdateWorkstreamMemberRequest$1, UpdateWorkstreamMemberResponse as UpdateWorkstreamMemberResponse$1, UpdateWorkstreamRequest as UpdateWorkstreamRequest$1, UpdateWorkstreamResponse as UpdateWorkstreamResponse$1, WithdrawSubmissionRequest as WithdrawSubmissionRequest$1, WithdrawSubmissionResponse as WithdrawSubmissionResponse$1 } from "../../datagateway/v1/contract_model_pb";
import { MyAssignedAction } from "./ryugu_pb";
import { MyCaptureDecision, MyCaptureTask } from "../../datagateway/v1/capture_pb";
import { AttentionItem } from "../../datagateway/v1/attention_pb";
/**
 * @generated from message mono.ryugu.v1.CreateDutyRequest
 */ export class CreateDutyRequest extends Message {
    static fromBinary(bytes, options) {
        return new CreateDutyRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CreateDutyRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CreateDutyRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CreateDutyRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.CreateDutyRequest body = 1;
   */ _define_property(this, "body", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(CreateDutyRequest, "runtime", proto3);
_define_property(CreateDutyRequest, "typeName", "mono.ryugu.v1.CreateDutyRequest");
_define_property(CreateDutyRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "body",
            kind: "message",
            T: CreateDutyRequest$1
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.CreateDutyResponse
 */ export class CreateDutyResponse extends Message {
    static fromBinary(bytes, options) {
        return new CreateDutyResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CreateDutyResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CreateDutyResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CreateDutyResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.CreateDutyResponse body = 1;
   */ _define_property(this, "body", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(CreateDutyResponse, "runtime", proto3);
_define_property(CreateDutyResponse, "typeName", "mono.ryugu.v1.CreateDutyResponse");
_define_property(CreateDutyResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "body",
            kind: "message",
            T: CreateDutyResponse$1
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.UpdateDutyRequest
 */ export class UpdateDutyRequest extends Message {
    static fromBinary(bytes, options) {
        return new UpdateDutyRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UpdateDutyRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UpdateDutyRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UpdateDutyRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.UpdateDutyRequest body = 1;
   */ _define_property(this, "body", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(UpdateDutyRequest, "runtime", proto3);
_define_property(UpdateDutyRequest, "typeName", "mono.ryugu.v1.UpdateDutyRequest");
_define_property(UpdateDutyRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "body",
            kind: "message",
            T: UpdateDutyRequest$1
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.UpdateDutyResponse
 */ export class UpdateDutyResponse extends Message {
    static fromBinary(bytes, options) {
        return new UpdateDutyResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UpdateDutyResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UpdateDutyResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UpdateDutyResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.UpdateDutyResponse body = 1;
   */ _define_property(this, "body", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(UpdateDutyResponse, "runtime", proto3);
_define_property(UpdateDutyResponse, "typeName", "mono.ryugu.v1.UpdateDutyResponse");
_define_property(UpdateDutyResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "body",
            kind: "message",
            T: UpdateDutyResponse$1
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.DeleteDutyRequest
 */ export class DeleteDutyRequest extends Message {
    static fromBinary(bytes, options) {
        return new DeleteDutyRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new DeleteDutyRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new DeleteDutyRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(DeleteDutyRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.DeleteDutyRequest body = 1;
   */ _define_property(this, "body", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(DeleteDutyRequest, "runtime", proto3);
_define_property(DeleteDutyRequest, "typeName", "mono.ryugu.v1.DeleteDutyRequest");
_define_property(DeleteDutyRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "body",
            kind: "message",
            T: DeleteDutyRequest$1
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.DeleteDutyResponse
 */ export class DeleteDutyResponse extends Message {
    static fromBinary(bytes, options) {
        return new DeleteDutyResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new DeleteDutyResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new DeleteDutyResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(DeleteDutyResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.DeleteDutyResponse body = 1;
   */ _define_property(this, "body", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(DeleteDutyResponse, "runtime", proto3);
_define_property(DeleteDutyResponse, "typeName", "mono.ryugu.v1.DeleteDutyResponse");
_define_property(DeleteDutyResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "body",
            kind: "message",
            T: DeleteDutyResponse$1
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.GetDutyRequest
 */ export class GetDutyRequest extends Message {
    static fromBinary(bytes, options) {
        return new GetDutyRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetDutyRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetDutyRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetDutyRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.GetDutyRequest body = 1;
   */ _define_property(this, "body", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetDutyRequest, "runtime", proto3);
_define_property(GetDutyRequest, "typeName", "mono.ryugu.v1.GetDutyRequest");
_define_property(GetDutyRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "body",
            kind: "message",
            T: GetDutyRequest$1
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.GetDutyResponse
 */ export class GetDutyResponse extends Message {
    static fromBinary(bytes, options) {
        return new GetDutyResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetDutyResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetDutyResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetDutyResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.GetDutyResponse body = 1;
   */ _define_property(this, "body", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetDutyResponse, "runtime", proto3);
_define_property(GetDutyResponse, "typeName", "mono.ryugu.v1.GetDutyResponse");
_define_property(GetDutyResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "body",
            kind: "message",
            T: GetDutyResponse$1
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.ListDutiesRequest
 */ export class ListDutiesRequest extends Message {
    static fromBinary(bytes, options) {
        return new ListDutiesRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListDutiesRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListDutiesRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListDutiesRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.ListDutiesRequest body = 1;
   */ _define_property(this, "body", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListDutiesRequest, "runtime", proto3);
_define_property(ListDutiesRequest, "typeName", "mono.ryugu.v1.ListDutiesRequest");
_define_property(ListDutiesRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "body",
            kind: "message",
            T: ListDutiesRequest$1
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.ListDutiesResponse
 */ export class ListDutiesResponse extends Message {
    static fromBinary(bytes, options) {
        return new ListDutiesResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListDutiesResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListDutiesResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListDutiesResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.ListDutiesResponse body = 1;
   */ _define_property(this, "body", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListDutiesResponse, "runtime", proto3);
_define_property(ListDutiesResponse, "typeName", "mono.ryugu.v1.ListDutiesResponse");
_define_property(ListDutiesResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "body",
            kind: "message",
            T: ListDutiesResponse$1
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.CreateScheduleRuleRequest
 */ export class CreateScheduleRuleRequest extends Message {
    static fromBinary(bytes, options) {
        return new CreateScheduleRuleRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CreateScheduleRuleRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CreateScheduleRuleRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CreateScheduleRuleRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.CreateScheduleRuleRequest body = 1;
   */ _define_property(this, "body", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(CreateScheduleRuleRequest, "runtime", proto3);
_define_property(CreateScheduleRuleRequest, "typeName", "mono.ryugu.v1.CreateScheduleRuleRequest");
_define_property(CreateScheduleRuleRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "body",
            kind: "message",
            T: CreateScheduleRuleRequest$1
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.CreateScheduleRuleResponse
 */ export class CreateScheduleRuleResponse extends Message {
    static fromBinary(bytes, options) {
        return new CreateScheduleRuleResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CreateScheduleRuleResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CreateScheduleRuleResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CreateScheduleRuleResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.CreateScheduleRuleResponse body = 1;
   */ _define_property(this, "body", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(CreateScheduleRuleResponse, "runtime", proto3);
_define_property(CreateScheduleRuleResponse, "typeName", "mono.ryugu.v1.CreateScheduleRuleResponse");
_define_property(CreateScheduleRuleResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "body",
            kind: "message",
            T: CreateScheduleRuleResponse$1
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.UpdateScheduleRuleRequest
 */ export class UpdateScheduleRuleRequest extends Message {
    static fromBinary(bytes, options) {
        return new UpdateScheduleRuleRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UpdateScheduleRuleRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UpdateScheduleRuleRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UpdateScheduleRuleRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.UpdateScheduleRuleRequest body = 1;
   */ _define_property(this, "body", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(UpdateScheduleRuleRequest, "runtime", proto3);
_define_property(UpdateScheduleRuleRequest, "typeName", "mono.ryugu.v1.UpdateScheduleRuleRequest");
_define_property(UpdateScheduleRuleRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "body",
            kind: "message",
            T: UpdateScheduleRuleRequest$1
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.UpdateScheduleRuleResponse
 */ export class UpdateScheduleRuleResponse extends Message {
    static fromBinary(bytes, options) {
        return new UpdateScheduleRuleResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UpdateScheduleRuleResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UpdateScheduleRuleResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UpdateScheduleRuleResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.UpdateScheduleRuleResponse body = 1;
   */ _define_property(this, "body", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(UpdateScheduleRuleResponse, "runtime", proto3);
_define_property(UpdateScheduleRuleResponse, "typeName", "mono.ryugu.v1.UpdateScheduleRuleResponse");
_define_property(UpdateScheduleRuleResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "body",
            kind: "message",
            T: UpdateScheduleRuleResponse$1
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.DeleteScheduleRuleRequest
 */ export class DeleteScheduleRuleRequest extends Message {
    static fromBinary(bytes, options) {
        return new DeleteScheduleRuleRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new DeleteScheduleRuleRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new DeleteScheduleRuleRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(DeleteScheduleRuleRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.DeleteScheduleRuleRequest body = 1;
   */ _define_property(this, "body", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(DeleteScheduleRuleRequest, "runtime", proto3);
_define_property(DeleteScheduleRuleRequest, "typeName", "mono.ryugu.v1.DeleteScheduleRuleRequest");
_define_property(DeleteScheduleRuleRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "body",
            kind: "message",
            T: DeleteScheduleRuleRequest$1
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.DeleteScheduleRuleResponse
 */ export class DeleteScheduleRuleResponse extends Message {
    static fromBinary(bytes, options) {
        return new DeleteScheduleRuleResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new DeleteScheduleRuleResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new DeleteScheduleRuleResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(DeleteScheduleRuleResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.DeleteScheduleRuleResponse body = 1;
   */ _define_property(this, "body", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(DeleteScheduleRuleResponse, "runtime", proto3);
_define_property(DeleteScheduleRuleResponse, "typeName", "mono.ryugu.v1.DeleteScheduleRuleResponse");
_define_property(DeleteScheduleRuleResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "body",
            kind: "message",
            T: DeleteScheduleRuleResponse$1
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.AddOccurrenceRequest
 */ export class AddOccurrenceRequest extends Message {
    static fromBinary(bytes, options) {
        return new AddOccurrenceRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new AddOccurrenceRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new AddOccurrenceRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(AddOccurrenceRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.AddOccurrenceRequest body = 1;
   */ _define_property(this, "body", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(AddOccurrenceRequest, "runtime", proto3);
_define_property(AddOccurrenceRequest, "typeName", "mono.ryugu.v1.AddOccurrenceRequest");
_define_property(AddOccurrenceRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "body",
            kind: "message",
            T: AddOccurrenceRequest$1
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.AddOccurrenceResponse
 */ export class AddOccurrenceResponse extends Message {
    static fromBinary(bytes, options) {
        return new AddOccurrenceResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new AddOccurrenceResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new AddOccurrenceResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(AddOccurrenceResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.AddOccurrenceResponse body = 1;
   */ _define_property(this, "body", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(AddOccurrenceResponse, "runtime", proto3);
_define_property(AddOccurrenceResponse, "typeName", "mono.ryugu.v1.AddOccurrenceResponse");
_define_property(AddOccurrenceResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "body",
            kind: "message",
            T: AddOccurrenceResponse$1
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.RemoveOccurrenceRequest
 */ export class RemoveOccurrenceRequest extends Message {
    static fromBinary(bytes, options) {
        return new RemoveOccurrenceRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new RemoveOccurrenceRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new RemoveOccurrenceRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(RemoveOccurrenceRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.RemoveOccurrenceRequest body = 1;
   */ _define_property(this, "body", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(RemoveOccurrenceRequest, "runtime", proto3);
_define_property(RemoveOccurrenceRequest, "typeName", "mono.ryugu.v1.RemoveOccurrenceRequest");
_define_property(RemoveOccurrenceRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "body",
            kind: "message",
            T: RemoveOccurrenceRequest$1
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.RemoveOccurrenceResponse
 */ export class RemoveOccurrenceResponse extends Message {
    static fromBinary(bytes, options) {
        return new RemoveOccurrenceResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new RemoveOccurrenceResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new RemoveOccurrenceResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(RemoveOccurrenceResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.RemoveOccurrenceResponse body = 1;
   */ _define_property(this, "body", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(RemoveOccurrenceResponse, "runtime", proto3);
_define_property(RemoveOccurrenceResponse, "typeName", "mono.ryugu.v1.RemoveOccurrenceResponse");
_define_property(RemoveOccurrenceResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "body",
            kind: "message",
            T: RemoveOccurrenceResponse$1
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.MoveOccurrenceRequest
 */ export class MoveOccurrenceRequest extends Message {
    static fromBinary(bytes, options) {
        return new MoveOccurrenceRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new MoveOccurrenceRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new MoveOccurrenceRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(MoveOccurrenceRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.MoveOccurrenceRequest body = 1;
   */ _define_property(this, "body", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(MoveOccurrenceRequest, "runtime", proto3);
_define_property(MoveOccurrenceRequest, "typeName", "mono.ryugu.v1.MoveOccurrenceRequest");
_define_property(MoveOccurrenceRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "body",
            kind: "message",
            T: MoveOccurrenceRequest$1
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.MoveOccurrenceResponse
 */ export class MoveOccurrenceResponse extends Message {
    static fromBinary(bytes, options) {
        return new MoveOccurrenceResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new MoveOccurrenceResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new MoveOccurrenceResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(MoveOccurrenceResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.MoveOccurrenceResponse body = 1;
   */ _define_property(this, "body", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(MoveOccurrenceResponse, "runtime", proto3);
_define_property(MoveOccurrenceResponse, "typeName", "mono.ryugu.v1.MoveOccurrenceResponse");
_define_property(MoveOccurrenceResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "body",
            kind: "message",
            T: MoveOccurrenceResponse$1
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.ProposeOccurrenceWaiverRequest
 */ export class ProposeOccurrenceWaiverRequest extends Message {
    static fromBinary(bytes, options) {
        return new ProposeOccurrenceWaiverRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ProposeOccurrenceWaiverRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ProposeOccurrenceWaiverRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ProposeOccurrenceWaiverRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.ProposeOccurrenceWaiverRequest body = 1;
   */ _define_property(this, "body", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ProposeOccurrenceWaiverRequest, "runtime", proto3);
_define_property(ProposeOccurrenceWaiverRequest, "typeName", "mono.ryugu.v1.ProposeOccurrenceWaiverRequest");
_define_property(ProposeOccurrenceWaiverRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "body",
            kind: "message",
            T: ProposeOccurrenceWaiverRequest$1
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.ProposeOccurrenceWaiverResponse
 */ export class ProposeOccurrenceWaiverResponse extends Message {
    static fromBinary(bytes, options) {
        return new ProposeOccurrenceWaiverResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ProposeOccurrenceWaiverResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ProposeOccurrenceWaiverResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ProposeOccurrenceWaiverResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.ProposeOccurrenceWaiverResponse body = 1;
   */ _define_property(this, "body", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ProposeOccurrenceWaiverResponse, "runtime", proto3);
_define_property(ProposeOccurrenceWaiverResponse, "typeName", "mono.ryugu.v1.ProposeOccurrenceWaiverResponse");
_define_property(ProposeOccurrenceWaiverResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "body",
            kind: "message",
            T: ProposeOccurrenceWaiverResponse$1
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.ProposeOccurrenceNotOwedRequest
 */ export class ProposeOccurrenceNotOwedRequest extends Message {
    static fromBinary(bytes, options) {
        return new ProposeOccurrenceNotOwedRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ProposeOccurrenceNotOwedRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ProposeOccurrenceNotOwedRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ProposeOccurrenceNotOwedRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.ProposeOccurrenceNotOwedRequest body = 1;
   */ _define_property(this, "body", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ProposeOccurrenceNotOwedRequest, "runtime", proto3);
_define_property(ProposeOccurrenceNotOwedRequest, "typeName", "mono.ryugu.v1.ProposeOccurrenceNotOwedRequest");
_define_property(ProposeOccurrenceNotOwedRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "body",
            kind: "message",
            T: ProposeOccurrenceNotOwedRequest$1
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.ProposeOccurrenceNotOwedResponse
 */ export class ProposeOccurrenceNotOwedResponse extends Message {
    static fromBinary(bytes, options) {
        return new ProposeOccurrenceNotOwedResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ProposeOccurrenceNotOwedResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ProposeOccurrenceNotOwedResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ProposeOccurrenceNotOwedResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.ProposeOccurrenceNotOwedResponse body = 1;
   */ _define_property(this, "body", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ProposeOccurrenceNotOwedResponse, "runtime", proto3);
_define_property(ProposeOccurrenceNotOwedResponse, "typeName", "mono.ryugu.v1.ProposeOccurrenceNotOwedResponse");
_define_property(ProposeOccurrenceNotOwedResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "body",
            kind: "message",
            T: ProposeOccurrenceNotOwedResponse$1
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.ProposeOccurrenceExtensionRequest
 */ export class ProposeOccurrenceExtensionRequest extends Message {
    static fromBinary(bytes, options) {
        return new ProposeOccurrenceExtensionRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ProposeOccurrenceExtensionRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ProposeOccurrenceExtensionRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ProposeOccurrenceExtensionRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.ProposeOccurrenceExtensionRequest body = 1;
   */ _define_property(this, "body", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ProposeOccurrenceExtensionRequest, "runtime", proto3);
_define_property(ProposeOccurrenceExtensionRequest, "typeName", "mono.ryugu.v1.ProposeOccurrenceExtensionRequest");
_define_property(ProposeOccurrenceExtensionRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "body",
            kind: "message",
            T: ProposeOccurrenceExtensionRequest$1
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.ProposeOccurrenceExtensionResponse
 */ export class ProposeOccurrenceExtensionResponse extends Message {
    static fromBinary(bytes, options) {
        return new ProposeOccurrenceExtensionResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ProposeOccurrenceExtensionResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ProposeOccurrenceExtensionResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ProposeOccurrenceExtensionResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.ProposeOccurrenceExtensionResponse body = 1;
   */ _define_property(this, "body", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ProposeOccurrenceExtensionResponse, "runtime", proto3);
_define_property(ProposeOccurrenceExtensionResponse, "typeName", "mono.ryugu.v1.ProposeOccurrenceExtensionResponse");
_define_property(ProposeOccurrenceExtensionResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "body",
            kind: "message",
            T: ProposeOccurrenceExtensionResponse$1
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.ProposeSubmissionEditRequest
 */ export class ProposeSubmissionEditRequest extends Message {
    static fromBinary(bytes, options) {
        return new ProposeSubmissionEditRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ProposeSubmissionEditRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ProposeSubmissionEditRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ProposeSubmissionEditRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.ProposeSubmissionEditRequest body = 1;
   */ _define_property(this, "body", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ProposeSubmissionEditRequest, "runtime", proto3);
_define_property(ProposeSubmissionEditRequest, "typeName", "mono.ryugu.v1.ProposeSubmissionEditRequest");
_define_property(ProposeSubmissionEditRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "body",
            kind: "message",
            T: ProposeSubmissionEditRequest$1
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.ProposeSubmissionEditResponse
 */ export class ProposeSubmissionEditResponse extends Message {
    static fromBinary(bytes, options) {
        return new ProposeSubmissionEditResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ProposeSubmissionEditResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ProposeSubmissionEditResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ProposeSubmissionEditResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.ProposeSubmissionEditResponse body = 1;
   */ _define_property(this, "body", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ProposeSubmissionEditResponse, "runtime", proto3);
_define_property(ProposeSubmissionEditResponse, "typeName", "mono.ryugu.v1.ProposeSubmissionEditResponse");
_define_property(ProposeSubmissionEditResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "body",
            kind: "message",
            T: ProposeSubmissionEditResponse$1
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.ProposeSubmissionEvidenceRequest
 */ export class ProposeSubmissionEvidenceRequest extends Message {
    static fromBinary(bytes, options) {
        return new ProposeSubmissionEvidenceRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ProposeSubmissionEvidenceRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ProposeSubmissionEvidenceRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ProposeSubmissionEvidenceRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.ProposeSubmissionEvidenceRequest body = 1;
   */ _define_property(this, "body", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ProposeSubmissionEvidenceRequest, "runtime", proto3);
_define_property(ProposeSubmissionEvidenceRequest, "typeName", "mono.ryugu.v1.ProposeSubmissionEvidenceRequest");
_define_property(ProposeSubmissionEvidenceRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "body",
            kind: "message",
            T: ProposeSubmissionEvidenceRequest$1
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.ProposeSubmissionEvidenceResponse
 */ export class ProposeSubmissionEvidenceResponse extends Message {
    static fromBinary(bytes, options) {
        return new ProposeSubmissionEvidenceResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ProposeSubmissionEvidenceResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ProposeSubmissionEvidenceResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ProposeSubmissionEvidenceResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.ProposeSubmissionEvidenceResponse body = 1;
   */ _define_property(this, "body", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ProposeSubmissionEvidenceResponse, "runtime", proto3);
_define_property(ProposeSubmissionEvidenceResponse, "typeName", "mono.ryugu.v1.ProposeSubmissionEvidenceResponse");
_define_property(ProposeSubmissionEvidenceResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "body",
            kind: "message",
            T: ProposeSubmissionEvidenceResponse$1
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.ProposeWaiverEvidenceRequest
 */ export class ProposeWaiverEvidenceRequest extends Message {
    static fromBinary(bytes, options) {
        return new ProposeWaiverEvidenceRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ProposeWaiverEvidenceRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ProposeWaiverEvidenceRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ProposeWaiverEvidenceRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.ProposeWaiverEvidenceRequest body = 1;
   */ _define_property(this, "body", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ProposeWaiverEvidenceRequest, "runtime", proto3);
_define_property(ProposeWaiverEvidenceRequest, "typeName", "mono.ryugu.v1.ProposeWaiverEvidenceRequest");
_define_property(ProposeWaiverEvidenceRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "body",
            kind: "message",
            T: ProposeWaiverEvidenceRequest$1
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.ProposeWaiverEvidenceResponse
 */ export class ProposeWaiverEvidenceResponse extends Message {
    static fromBinary(bytes, options) {
        return new ProposeWaiverEvidenceResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ProposeWaiverEvidenceResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ProposeWaiverEvidenceResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ProposeWaiverEvidenceResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.ProposeWaiverEvidenceResponse body = 1;
   */ _define_property(this, "body", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ProposeWaiverEvidenceResponse, "runtime", proto3);
_define_property(ProposeWaiverEvidenceResponse, "typeName", "mono.ryugu.v1.ProposeWaiverEvidenceResponse");
_define_property(ProposeWaiverEvidenceResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "body",
            kind: "message",
            T: ProposeWaiverEvidenceResponse$1
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.ProposeExtensionEvidenceRequest
 */ export class ProposeExtensionEvidenceRequest extends Message {
    static fromBinary(bytes, options) {
        return new ProposeExtensionEvidenceRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ProposeExtensionEvidenceRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ProposeExtensionEvidenceRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ProposeExtensionEvidenceRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.ProposeExtensionEvidenceRequest body = 1;
   */ _define_property(this, "body", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ProposeExtensionEvidenceRequest, "runtime", proto3);
_define_property(ProposeExtensionEvidenceRequest, "typeName", "mono.ryugu.v1.ProposeExtensionEvidenceRequest");
_define_property(ProposeExtensionEvidenceRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "body",
            kind: "message",
            T: ProposeExtensionEvidenceRequest$1
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.ProposeExtensionEvidenceResponse
 */ export class ProposeExtensionEvidenceResponse extends Message {
    static fromBinary(bytes, options) {
        return new ProposeExtensionEvidenceResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ProposeExtensionEvidenceResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ProposeExtensionEvidenceResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ProposeExtensionEvidenceResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.ProposeExtensionEvidenceResponse body = 1;
   */ _define_property(this, "body", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ProposeExtensionEvidenceResponse, "runtime", proto3);
_define_property(ProposeExtensionEvidenceResponse, "typeName", "mono.ryugu.v1.ProposeExtensionEvidenceResponse");
_define_property(ProposeExtensionEvidenceResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "body",
            kind: "message",
            T: ProposeExtensionEvidenceResponse$1
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.ProposeWaiverEditRequest
 */ export class ProposeWaiverEditRequest extends Message {
    static fromBinary(bytes, options) {
        return new ProposeWaiverEditRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ProposeWaiverEditRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ProposeWaiverEditRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ProposeWaiverEditRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.ProposeWaiverEditRequest body = 1;
   */ _define_property(this, "body", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ProposeWaiverEditRequest, "runtime", proto3);
_define_property(ProposeWaiverEditRequest, "typeName", "mono.ryugu.v1.ProposeWaiverEditRequest");
_define_property(ProposeWaiverEditRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "body",
            kind: "message",
            T: ProposeWaiverEditRequest$1
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.ProposeWaiverEditResponse
 */ export class ProposeWaiverEditResponse extends Message {
    static fromBinary(bytes, options) {
        return new ProposeWaiverEditResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ProposeWaiverEditResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ProposeWaiverEditResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ProposeWaiverEditResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.ProposeWaiverEditResponse body = 1;
   */ _define_property(this, "body", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ProposeWaiverEditResponse, "runtime", proto3);
_define_property(ProposeWaiverEditResponse, "typeName", "mono.ryugu.v1.ProposeWaiverEditResponse");
_define_property(ProposeWaiverEditResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "body",
            kind: "message",
            T: ProposeWaiverEditResponse$1
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.RecordOccurrenceDecisionCorAnswerRequest
 */ export class RecordOccurrenceDecisionCorAnswerRequest extends Message {
    static fromBinary(bytes, options) {
        return new RecordOccurrenceDecisionCorAnswerRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new RecordOccurrenceDecisionCorAnswerRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new RecordOccurrenceDecisionCorAnswerRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(RecordOccurrenceDecisionCorAnswerRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.RecordOccurrenceDecisionCorAnswerRequest body = 1;
   */ _define_property(this, "body", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(RecordOccurrenceDecisionCorAnswerRequest, "runtime", proto3);
_define_property(RecordOccurrenceDecisionCorAnswerRequest, "typeName", "mono.ryugu.v1.RecordOccurrenceDecisionCorAnswerRequest");
_define_property(RecordOccurrenceDecisionCorAnswerRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "body",
            kind: "message",
            T: RecordOccurrenceDecisionCorAnswerRequest$1
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.RecordOccurrenceDecisionCorAnswerResponse
 */ export class RecordOccurrenceDecisionCorAnswerResponse extends Message {
    static fromBinary(bytes, options) {
        return new RecordOccurrenceDecisionCorAnswerResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new RecordOccurrenceDecisionCorAnswerResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new RecordOccurrenceDecisionCorAnswerResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(RecordOccurrenceDecisionCorAnswerResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.RecordOccurrenceDecisionCorAnswerResponse body = 1;
   */ _define_property(this, "body", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(RecordOccurrenceDecisionCorAnswerResponse, "runtime", proto3);
_define_property(RecordOccurrenceDecisionCorAnswerResponse, "typeName", "mono.ryugu.v1.RecordOccurrenceDecisionCorAnswerResponse");
_define_property(RecordOccurrenceDecisionCorAnswerResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "body",
            kind: "message",
            T: RecordOccurrenceDecisionCorAnswerResponse$1
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.ApproveOccurrenceDecisionRequest
 */ export class ApproveOccurrenceDecisionRequest extends Message {
    static fromBinary(bytes, options) {
        return new ApproveOccurrenceDecisionRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ApproveOccurrenceDecisionRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ApproveOccurrenceDecisionRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ApproveOccurrenceDecisionRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.ApproveOccurrenceDecisionRequest body = 1;
   */ _define_property(this, "body", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ApproveOccurrenceDecisionRequest, "runtime", proto3);
_define_property(ApproveOccurrenceDecisionRequest, "typeName", "mono.ryugu.v1.ApproveOccurrenceDecisionRequest");
_define_property(ApproveOccurrenceDecisionRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "body",
            kind: "message",
            T: ApproveOccurrenceDecisionRequest$1
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.ApproveOccurrenceDecisionResponse
 */ export class ApproveOccurrenceDecisionResponse extends Message {
    static fromBinary(bytes, options) {
        return new ApproveOccurrenceDecisionResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ApproveOccurrenceDecisionResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ApproveOccurrenceDecisionResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ApproveOccurrenceDecisionResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.ApproveOccurrenceDecisionResponse body = 1;
   */ _define_property(this, "body", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ApproveOccurrenceDecisionResponse, "runtime", proto3);
_define_property(ApproveOccurrenceDecisionResponse, "typeName", "mono.ryugu.v1.ApproveOccurrenceDecisionResponse");
_define_property(ApproveOccurrenceDecisionResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "body",
            kind: "message",
            T: ApproveOccurrenceDecisionResponse$1
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.RejectOccurrenceDecisionRequest
 */ export class RejectOccurrenceDecisionRequest extends Message {
    static fromBinary(bytes, options) {
        return new RejectOccurrenceDecisionRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new RejectOccurrenceDecisionRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new RejectOccurrenceDecisionRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(RejectOccurrenceDecisionRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.RejectOccurrenceDecisionRequest body = 1;
   */ _define_property(this, "body", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(RejectOccurrenceDecisionRequest, "runtime", proto3);
_define_property(RejectOccurrenceDecisionRequest, "typeName", "mono.ryugu.v1.RejectOccurrenceDecisionRequest");
_define_property(RejectOccurrenceDecisionRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "body",
            kind: "message",
            T: RejectOccurrenceDecisionRequest$1
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.RejectOccurrenceDecisionResponse
 */ export class RejectOccurrenceDecisionResponse extends Message {
    static fromBinary(bytes, options) {
        return new RejectOccurrenceDecisionResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new RejectOccurrenceDecisionResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new RejectOccurrenceDecisionResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(RejectOccurrenceDecisionResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.RejectOccurrenceDecisionResponse body = 1;
   */ _define_property(this, "body", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(RejectOccurrenceDecisionResponse, "runtime", proto3);
_define_property(RejectOccurrenceDecisionResponse, "typeName", "mono.ryugu.v1.RejectOccurrenceDecisionResponse");
_define_property(RejectOccurrenceDecisionResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "body",
            kind: "message",
            T: RejectOccurrenceDecisionResponse$1
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.ListOccurrenceDecisionsRequest
 */ export class ListOccurrenceDecisionsRequest extends Message {
    static fromBinary(bytes, options) {
        return new ListOccurrenceDecisionsRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListOccurrenceDecisionsRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListOccurrenceDecisionsRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListOccurrenceDecisionsRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.ListOccurrenceDecisionsRequest body = 1;
   */ _define_property(this, "body", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListOccurrenceDecisionsRequest, "runtime", proto3);
_define_property(ListOccurrenceDecisionsRequest, "typeName", "mono.ryugu.v1.ListOccurrenceDecisionsRequest");
_define_property(ListOccurrenceDecisionsRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "body",
            kind: "message",
            T: ListOccurrenceDecisionsRequest$1
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.ListOccurrenceDecisionsResponse
 */ export class ListOccurrenceDecisionsResponse extends Message {
    static fromBinary(bytes, options) {
        return new ListOccurrenceDecisionsResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListOccurrenceDecisionsResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListOccurrenceDecisionsResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListOccurrenceDecisionsResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.ListOccurrenceDecisionsResponse body = 1;
   */ _define_property(this, "body", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListOccurrenceDecisionsResponse, "runtime", proto3);
_define_property(ListOccurrenceDecisionsResponse, "typeName", "mono.ryugu.v1.ListOccurrenceDecisionsResponse");
_define_property(ListOccurrenceDecisionsResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "body",
            kind: "message",
            T: ListOccurrenceDecisionsResponse$1
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.GetOccurrenceRequest
 */ export class GetOccurrenceRequest extends Message {
    static fromBinary(bytes, options) {
        return new GetOccurrenceRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetOccurrenceRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetOccurrenceRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetOccurrenceRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.GetOccurrenceRequest body = 1;
   */ _define_property(this, "body", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetOccurrenceRequest, "runtime", proto3);
_define_property(GetOccurrenceRequest, "typeName", "mono.ryugu.v1.GetOccurrenceRequest");
_define_property(GetOccurrenceRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "body",
            kind: "message",
            T: GetOccurrenceRequest$1
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.GetOccurrenceResponse
 */ export class GetOccurrenceResponse extends Message {
    static fromBinary(bytes, options) {
        return new GetOccurrenceResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetOccurrenceResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetOccurrenceResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetOccurrenceResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.GetOccurrenceResponse body = 1;
   */ _define_property(this, "body", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetOccurrenceResponse, "runtime", proto3);
_define_property(GetOccurrenceResponse, "typeName", "mono.ryugu.v1.GetOccurrenceResponse");
_define_property(GetOccurrenceResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "body",
            kind: "message",
            T: GetOccurrenceResponse$1
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.ListProgramSubmissionsRequest
 */ export class ListProgramSubmissionsRequest extends Message {
    static fromBinary(bytes, options) {
        return new ListProgramSubmissionsRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListProgramSubmissionsRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListProgramSubmissionsRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListProgramSubmissionsRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.ListProgramSubmissionsRequest body = 1;
   */ _define_property(this, "body", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListProgramSubmissionsRequest, "runtime", proto3);
_define_property(ListProgramSubmissionsRequest, "typeName", "mono.ryugu.v1.ListProgramSubmissionsRequest");
_define_property(ListProgramSubmissionsRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "body",
            kind: "message",
            T: ListProgramSubmissionsRequest$1
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.ListProgramSubmissionsResponse
 */ export class ListProgramSubmissionsResponse extends Message {
    static fromBinary(bytes, options) {
        return new ListProgramSubmissionsResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListProgramSubmissionsResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListProgramSubmissionsResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListProgramSubmissionsResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.ListProgramSubmissionsResponse body = 1;
   */ _define_property(this, "body", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListProgramSubmissionsResponse, "runtime", proto3);
_define_property(ListProgramSubmissionsResponse, "typeName", "mono.ryugu.v1.ListProgramSubmissionsResponse");
_define_property(ListProgramSubmissionsResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "body",
            kind: "message",
            T: ListProgramSubmissionsResponse$1
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.ListOccurrencesRequest
 */ export class ListOccurrencesRequest extends Message {
    static fromBinary(bytes, options) {
        return new ListOccurrencesRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListOccurrencesRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListOccurrencesRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListOccurrencesRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.ListOccurrencesRequest body = 1;
   */ _define_property(this, "body", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListOccurrencesRequest, "runtime", proto3);
_define_property(ListOccurrencesRequest, "typeName", "mono.ryugu.v1.ListOccurrencesRequest");
_define_property(ListOccurrencesRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "body",
            kind: "message",
            T: ListOccurrencesRequest$1
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.ListOccurrencesResponse
 */ export class ListOccurrencesResponse extends Message {
    static fromBinary(bytes, options) {
        return new ListOccurrencesResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListOccurrencesResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListOccurrencesResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListOccurrencesResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.ListOccurrencesResponse body = 1;
   */ _define_property(this, "body", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListOccurrencesResponse, "runtime", proto3);
_define_property(ListOccurrencesResponse, "typeName", "mono.ryugu.v1.ListOccurrencesResponse");
_define_property(ListOccurrencesResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "body",
            kind: "message",
            T: ListOccurrencesResponse$1
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.ListWorkstreamWindowCountsRequest
 */ export class ListWorkstreamWindowCountsRequest extends Message {
    static fromBinary(bytes, options) {
        return new ListWorkstreamWindowCountsRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListWorkstreamWindowCountsRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListWorkstreamWindowCountsRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListWorkstreamWindowCountsRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.ListWorkstreamWindowCountsRequest body = 1;
   */ _define_property(this, "body", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListWorkstreamWindowCountsRequest, "runtime", proto3);
_define_property(ListWorkstreamWindowCountsRequest, "typeName", "mono.ryugu.v1.ListWorkstreamWindowCountsRequest");
_define_property(ListWorkstreamWindowCountsRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "body",
            kind: "message",
            T: ListWorkstreamWindowCountsRequest$1
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.ListWorkstreamWindowCountsResponse
 */ export class ListWorkstreamWindowCountsResponse extends Message {
    static fromBinary(bytes, options) {
        return new ListWorkstreamWindowCountsResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListWorkstreamWindowCountsResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListWorkstreamWindowCountsResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListWorkstreamWindowCountsResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.ListWorkstreamWindowCountsResponse body = 1;
   */ _define_property(this, "body", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListWorkstreamWindowCountsResponse, "runtime", proto3);
_define_property(ListWorkstreamWindowCountsResponse, "typeName", "mono.ryugu.v1.ListWorkstreamWindowCountsResponse");
_define_property(ListWorkstreamWindowCountsResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "body",
            kind: "message",
            T: ListWorkstreamWindowCountsResponse$1
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.GetPortfolioDeliverySummaryRequest
 */ export class GetPortfolioDeliverySummaryRequest extends Message {
    static fromBinary(bytes, options) {
        return new GetPortfolioDeliverySummaryRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetPortfolioDeliverySummaryRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetPortfolioDeliverySummaryRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetPortfolioDeliverySummaryRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.GetPortfolioDeliverySummaryRequest body = 1;
   */ _define_property(this, "body", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetPortfolioDeliverySummaryRequest, "runtime", proto3);
_define_property(GetPortfolioDeliverySummaryRequest, "typeName", "mono.ryugu.v1.GetPortfolioDeliverySummaryRequest");
_define_property(GetPortfolioDeliverySummaryRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "body",
            kind: "message",
            T: GetPortfolioDeliverySummaryRequest$1
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.RemindOccurrenceRequest
 */ export class RemindOccurrenceRequest extends Message {
    static fromBinary(bytes, options) {
        return new RemindOccurrenceRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new RemindOccurrenceRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new RemindOccurrenceRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(RemindOccurrenceRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.RemindOccurrenceRequest body = 1;
   */ _define_property(this, "body", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(RemindOccurrenceRequest, "runtime", proto3);
_define_property(RemindOccurrenceRequest, "typeName", "mono.ryugu.v1.RemindOccurrenceRequest");
_define_property(RemindOccurrenceRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "body",
            kind: "message",
            T: RemindOccurrenceRequest$1
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.RemindOccurrenceResponse
 */ export class RemindOccurrenceResponse extends Message {
    static fromBinary(bytes, options) {
        return new RemindOccurrenceResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new RemindOccurrenceResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new RemindOccurrenceResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(RemindOccurrenceResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.RemindOccurrenceResponse body = 1;
   */ _define_property(this, "body", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(RemindOccurrenceResponse, "runtime", proto3);
_define_property(RemindOccurrenceResponse, "typeName", "mono.ryugu.v1.RemindOccurrenceResponse");
_define_property(RemindOccurrenceResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "body",
            kind: "message",
            T: RemindOccurrenceResponse$1
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.ListSavedViewsRequest
 */ export class ListSavedViewsRequest extends Message {
    static fromBinary(bytes, options) {
        return new ListSavedViewsRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListSavedViewsRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListSavedViewsRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListSavedViewsRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.ListSavedViewsRequest body = 1;
   */ _define_property(this, "body", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListSavedViewsRequest, "runtime", proto3);
_define_property(ListSavedViewsRequest, "typeName", "mono.ryugu.v1.ListSavedViewsRequest");
_define_property(ListSavedViewsRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "body",
            kind: "message",
            T: ListSavedViewsRequest$1
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.ListSavedViewsResponse
 */ export class ListSavedViewsResponse extends Message {
    static fromBinary(bytes, options) {
        return new ListSavedViewsResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListSavedViewsResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListSavedViewsResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListSavedViewsResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.ListSavedViewsResponse body = 1;
   */ _define_property(this, "body", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListSavedViewsResponse, "runtime", proto3);
_define_property(ListSavedViewsResponse, "typeName", "mono.ryugu.v1.ListSavedViewsResponse");
_define_property(ListSavedViewsResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "body",
            kind: "message",
            T: ListSavedViewsResponse$1
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.SaveViewRequest
 */ export class SaveViewRequest extends Message {
    static fromBinary(bytes, options) {
        return new SaveViewRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new SaveViewRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new SaveViewRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(SaveViewRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.SaveViewRequest body = 1;
   */ _define_property(this, "body", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(SaveViewRequest, "runtime", proto3);
_define_property(SaveViewRequest, "typeName", "mono.ryugu.v1.SaveViewRequest");
_define_property(SaveViewRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "body",
            kind: "message",
            T: SaveViewRequest$1
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.SaveViewResponse
 */ export class SaveViewResponse extends Message {
    static fromBinary(bytes, options) {
        return new SaveViewResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new SaveViewResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new SaveViewResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(SaveViewResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.SaveViewResponse body = 1;
   */ _define_property(this, "body", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(SaveViewResponse, "runtime", proto3);
_define_property(SaveViewResponse, "typeName", "mono.ryugu.v1.SaveViewResponse");
_define_property(SaveViewResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "body",
            kind: "message",
            T: SaveViewResponse$1
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.DeleteSavedViewRequest
 */ export class DeleteSavedViewRequest extends Message {
    static fromBinary(bytes, options) {
        return new DeleteSavedViewRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new DeleteSavedViewRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new DeleteSavedViewRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(DeleteSavedViewRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.DeleteSavedViewRequest body = 1;
   */ _define_property(this, "body", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(DeleteSavedViewRequest, "runtime", proto3);
_define_property(DeleteSavedViewRequest, "typeName", "mono.ryugu.v1.DeleteSavedViewRequest");
_define_property(DeleteSavedViewRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "body",
            kind: "message",
            T: DeleteSavedViewRequest$1
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.DeleteSavedViewResponse
 */ export class DeleteSavedViewResponse extends Message {
    static fromBinary(bytes, options) {
        return new DeleteSavedViewResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new DeleteSavedViewResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new DeleteSavedViewResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(DeleteSavedViewResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.DeleteSavedViewResponse body = 1;
   */ _define_property(this, "body", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(DeleteSavedViewResponse, "runtime", proto3);
_define_property(DeleteSavedViewResponse, "typeName", "mono.ryugu.v1.DeleteSavedViewResponse");
_define_property(DeleteSavedViewResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "body",
            kind: "message",
            T: DeleteSavedViewResponse$1
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.ListAttentionItemsRequest
 */ export class ListAttentionItemsRequest extends Message {
    static fromBinary(bytes, options) {
        return new ListAttentionItemsRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListAttentionItemsRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListAttentionItemsRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListAttentionItemsRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.ListAttentionItemsRequest body = 1;
   */ _define_property(this, "body", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListAttentionItemsRequest, "runtime", proto3);
_define_property(ListAttentionItemsRequest, "typeName", "mono.ryugu.v1.ListAttentionItemsRequest");
_define_property(ListAttentionItemsRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "body",
            kind: "message",
            T: ListAttentionItemsRequest$1
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.ListAttentionItemsResponse
 */ export class ListAttentionItemsResponse extends Message {
    static fromBinary(bytes, options) {
        return new ListAttentionItemsResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListAttentionItemsResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListAttentionItemsResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListAttentionItemsResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.ListAttentionItemsResponse body = 1;
   */ _define_property(this, "body", void 0), /**
   * hidden_count as in GetPortfolioDeliverySummaryResponse.
   *
   * @generated from field: int32 hidden_count = 2;
   */ _define_property(this, "hiddenCount", 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListAttentionItemsResponse, "runtime", proto3);
_define_property(ListAttentionItemsResponse, "typeName", "mono.ryugu.v1.ListAttentionItemsResponse");
_define_property(ListAttentionItemsResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "body",
            kind: "message",
            T: ListAttentionItemsResponse$1
        },
        {
            no: 2,
            name: "hidden_count",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.ListPortfolioOccurrencesRequest
 */ export class ListPortfolioOccurrencesRequest extends Message {
    static fromBinary(bytes, options) {
        return new ListPortfolioOccurrencesRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListPortfolioOccurrencesRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListPortfolioOccurrencesRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListPortfolioOccurrencesRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.ListPortfolioOccurrencesRequest body = 1;
   */ _define_property(this, "body", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListPortfolioOccurrencesRequest, "runtime", proto3);
_define_property(ListPortfolioOccurrencesRequest, "typeName", "mono.ryugu.v1.ListPortfolioOccurrencesRequest");
_define_property(ListPortfolioOccurrencesRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "body",
            kind: "message",
            T: ListPortfolioOccurrencesRequest$1
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.ListPortfolioOccurrencesResponse
 */ export class ListPortfolioOccurrencesResponse extends Message {
    static fromBinary(bytes, options) {
        return new ListPortfolioOccurrencesResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListPortfolioOccurrencesResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListPortfolioOccurrencesResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListPortfolioOccurrencesResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.ListPortfolioOccurrencesResponse body = 1;
   */ _define_property(this, "body", void 0), /**
   * hidden_count as in GetPortfolioDeliverySummaryResponse.
   *
   * @generated from field: int32 hidden_count = 2;
   */ _define_property(this, "hiddenCount", 0), /**
   * program_options are the programs the viewer can see in the portfolio
   * and sector asked for (before the program filter), by name, for the
   * filter bar.
   *
   * @generated from field: repeated mono.datagateway.v1.FacetOption program_options = 3;
   */ _define_property(this, "programOptions", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListPortfolioOccurrencesResponse, "runtime", proto3);
_define_property(ListPortfolioOccurrencesResponse, "typeName", "mono.ryugu.v1.ListPortfolioOccurrencesResponse");
_define_property(ListPortfolioOccurrencesResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "body",
            kind: "message",
            T: ListPortfolioOccurrencesResponse$1
        },
        {
            no: 2,
            name: "hidden_count",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 3,
            name: "program_options",
            kind: "message",
            T: FacetOption,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.GetPortfolioDeliverySummaryResponse
 */ export class GetPortfolioDeliverySummaryResponse extends Message {
    static fromBinary(bytes, options) {
        return new GetPortfolioDeliverySummaryResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetPortfolioDeliverySummaryResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetPortfolioDeliverySummaryResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetPortfolioDeliverySummaryResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.GetPortfolioDeliverySummaryResponse body = 1;
   */ _define_property(this, "body", void 0), /**
   * hidden_count is how many of the tenant's programs in the portfolio and
   * sector asked for the viewer cannot see: left out of every count.
   *
   * @generated from field: int32 hidden_count = 2;
   */ _define_property(this, "hiddenCount", 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetPortfolioDeliverySummaryResponse, "runtime", proto3);
_define_property(GetPortfolioDeliverySummaryResponse, "typeName", "mono.ryugu.v1.GetPortfolioDeliverySummaryResponse");
_define_property(GetPortfolioDeliverySummaryResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "body",
            kind: "message",
            T: GetPortfolioDeliverySummaryResponse$1
        },
        {
            no: 2,
            name: "hidden_count",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.LogContractEventRequest
 */ export class LogContractEventRequest extends Message {
    static fromBinary(bytes, options) {
        return new LogContractEventRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new LogContractEventRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new LogContractEventRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(LogContractEventRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.LogContractEventRequest body = 1;
   */ _define_property(this, "body", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(LogContractEventRequest, "runtime", proto3);
_define_property(LogContractEventRequest, "typeName", "mono.ryugu.v1.LogContractEventRequest");
_define_property(LogContractEventRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "body",
            kind: "message",
            T: LogContractEventRequest$1
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.LogContractEventResponse
 */ export class LogContractEventResponse extends Message {
    static fromBinary(bytes, options) {
        return new LogContractEventResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new LogContractEventResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new LogContractEventResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(LogContractEventResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.LogContractEventResponse body = 1;
   */ _define_property(this, "body", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(LogContractEventResponse, "runtime", proto3);
_define_property(LogContractEventResponse, "typeName", "mono.ryugu.v1.LogContractEventResponse");
_define_property(LogContractEventResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "body",
            kind: "message",
            T: LogContractEventResponse$1
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.CreateWorkstreamRequest
 */ export class CreateWorkstreamRequest extends Message {
    static fromBinary(bytes, options) {
        return new CreateWorkstreamRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CreateWorkstreamRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CreateWorkstreamRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CreateWorkstreamRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.CreateWorkstreamRequest body = 1;
   */ _define_property(this, "body", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(CreateWorkstreamRequest, "runtime", proto3);
_define_property(CreateWorkstreamRequest, "typeName", "mono.ryugu.v1.CreateWorkstreamRequest");
_define_property(CreateWorkstreamRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "body",
            kind: "message",
            T: CreateWorkstreamRequest$1
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.CreateWorkstreamResponse
 */ export class CreateWorkstreamResponse extends Message {
    static fromBinary(bytes, options) {
        return new CreateWorkstreamResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CreateWorkstreamResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CreateWorkstreamResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CreateWorkstreamResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.CreateWorkstreamResponse body = 1;
   */ _define_property(this, "body", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(CreateWorkstreamResponse, "runtime", proto3);
_define_property(CreateWorkstreamResponse, "typeName", "mono.ryugu.v1.CreateWorkstreamResponse");
_define_property(CreateWorkstreamResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "body",
            kind: "message",
            T: CreateWorkstreamResponse$1
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.UpdateWorkstreamRequest
 */ export class UpdateWorkstreamRequest extends Message {
    static fromBinary(bytes, options) {
        return new UpdateWorkstreamRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UpdateWorkstreamRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UpdateWorkstreamRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UpdateWorkstreamRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.UpdateWorkstreamRequest body = 1;
   */ _define_property(this, "body", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(UpdateWorkstreamRequest, "runtime", proto3);
_define_property(UpdateWorkstreamRequest, "typeName", "mono.ryugu.v1.UpdateWorkstreamRequest");
_define_property(UpdateWorkstreamRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "body",
            kind: "message",
            T: UpdateWorkstreamRequest$1
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.UpdateWorkstreamResponse
 */ export class UpdateWorkstreamResponse extends Message {
    static fromBinary(bytes, options) {
        return new UpdateWorkstreamResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UpdateWorkstreamResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UpdateWorkstreamResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UpdateWorkstreamResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.UpdateWorkstreamResponse body = 1;
   */ _define_property(this, "body", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(UpdateWorkstreamResponse, "runtime", proto3);
_define_property(UpdateWorkstreamResponse, "typeName", "mono.ryugu.v1.UpdateWorkstreamResponse");
_define_property(UpdateWorkstreamResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "body",
            kind: "message",
            T: UpdateWorkstreamResponse$1
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.GetWorkstreamRequest
 */ export class GetWorkstreamRequest extends Message {
    static fromBinary(bytes, options) {
        return new GetWorkstreamRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetWorkstreamRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetWorkstreamRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetWorkstreamRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.GetWorkstreamRequest body = 1;
   */ _define_property(this, "body", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetWorkstreamRequest, "runtime", proto3);
_define_property(GetWorkstreamRequest, "typeName", "mono.ryugu.v1.GetWorkstreamRequest");
_define_property(GetWorkstreamRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "body",
            kind: "message",
            T: GetWorkstreamRequest$1
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.GetWorkstreamResponse
 */ export class GetWorkstreamResponse extends Message {
    static fromBinary(bytes, options) {
        return new GetWorkstreamResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetWorkstreamResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetWorkstreamResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetWorkstreamResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.GetWorkstreamResponse body = 1;
   */ _define_property(this, "body", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetWorkstreamResponse, "runtime", proto3);
_define_property(GetWorkstreamResponse, "typeName", "mono.ryugu.v1.GetWorkstreamResponse");
_define_property(GetWorkstreamResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "body",
            kind: "message",
            T: GetWorkstreamResponse$1
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.ListWorkstreamsRequest
 */ export class ListWorkstreamsRequest extends Message {
    static fromBinary(bytes, options) {
        return new ListWorkstreamsRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListWorkstreamsRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListWorkstreamsRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListWorkstreamsRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.ListWorkstreamsRequest body = 1;
   */ _define_property(this, "body", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListWorkstreamsRequest, "runtime", proto3);
_define_property(ListWorkstreamsRequest, "typeName", "mono.ryugu.v1.ListWorkstreamsRequest");
_define_property(ListWorkstreamsRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "body",
            kind: "message",
            T: ListWorkstreamsRequest$1
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.ListWorkstreamsResponse
 */ export class ListWorkstreamsResponse extends Message {
    static fromBinary(bytes, options) {
        return new ListWorkstreamsResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListWorkstreamsResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListWorkstreamsResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListWorkstreamsResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.ListWorkstreamsResponse body = 1;
   */ _define_property(this, "body", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListWorkstreamsResponse, "runtime", proto3);
_define_property(ListWorkstreamsResponse, "typeName", "mono.ryugu.v1.ListWorkstreamsResponse");
_define_property(ListWorkstreamsResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "body",
            kind: "message",
            T: ListWorkstreamsResponse$1
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.LinkWorkstreamLineageRequest
 */ export class LinkWorkstreamLineageRequest extends Message {
    static fromBinary(bytes, options) {
        return new LinkWorkstreamLineageRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new LinkWorkstreamLineageRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new LinkWorkstreamLineageRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(LinkWorkstreamLineageRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.LinkWorkstreamLineageRequest body = 1;
   */ _define_property(this, "body", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(LinkWorkstreamLineageRequest, "runtime", proto3);
_define_property(LinkWorkstreamLineageRequest, "typeName", "mono.ryugu.v1.LinkWorkstreamLineageRequest");
_define_property(LinkWorkstreamLineageRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "body",
            kind: "message",
            T: LinkWorkstreamLineageRequest$1
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.LinkWorkstreamLineageResponse
 */ export class LinkWorkstreamLineageResponse extends Message {
    static fromBinary(bytes, options) {
        return new LinkWorkstreamLineageResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new LinkWorkstreamLineageResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new LinkWorkstreamLineageResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(LinkWorkstreamLineageResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.LinkWorkstreamLineageResponse body = 1;
   */ _define_property(this, "body", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(LinkWorkstreamLineageResponse, "runtime", proto3);
_define_property(LinkWorkstreamLineageResponse, "typeName", "mono.ryugu.v1.LinkWorkstreamLineageResponse");
_define_property(LinkWorkstreamLineageResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "body",
            kind: "message",
            T: LinkWorkstreamLineageResponse$1
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.CreateSowRequest
 */ export class CreateSowRequest extends Message {
    static fromBinary(bytes, options) {
        return new CreateSowRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CreateSowRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CreateSowRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CreateSowRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.CreateSowRequest body = 1;
   */ _define_property(this, "body", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(CreateSowRequest, "runtime", proto3);
_define_property(CreateSowRequest, "typeName", "mono.ryugu.v1.CreateSowRequest");
_define_property(CreateSowRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "body",
            kind: "message",
            T: CreateSowRequest$1
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.CreateSowResponse
 */ export class CreateSowResponse extends Message {
    static fromBinary(bytes, options) {
        return new CreateSowResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CreateSowResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CreateSowResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CreateSowResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.CreateSowResponse body = 1;
   */ _define_property(this, "body", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(CreateSowResponse, "runtime", proto3);
_define_property(CreateSowResponse, "typeName", "mono.ryugu.v1.CreateSowResponse");
_define_property(CreateSowResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "body",
            kind: "message",
            T: CreateSowResponse$1
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.SetExerciseWorkstreamRequest
 */ export class SetExerciseWorkstreamRequest extends Message {
    static fromBinary(bytes, options) {
        return new SetExerciseWorkstreamRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new SetExerciseWorkstreamRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new SetExerciseWorkstreamRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(SetExerciseWorkstreamRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.SetExerciseWorkstreamRequest body = 1;
   */ _define_property(this, "body", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(SetExerciseWorkstreamRequest, "runtime", proto3);
_define_property(SetExerciseWorkstreamRequest, "typeName", "mono.ryugu.v1.SetExerciseWorkstreamRequest");
_define_property(SetExerciseWorkstreamRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "body",
            kind: "message",
            T: SetExerciseWorkstreamRequest$1
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.SetExerciseWorkstreamResponse
 */ export class SetExerciseWorkstreamResponse extends Message {
    static fromBinary(bytes, options) {
        return new SetExerciseWorkstreamResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new SetExerciseWorkstreamResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new SetExerciseWorkstreamResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(SetExerciseWorkstreamResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.SetExerciseWorkstreamResponse body = 1;
   */ _define_property(this, "body", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(SetExerciseWorkstreamResponse, "runtime", proto3);
_define_property(SetExerciseWorkstreamResponse, "typeName", "mono.ryugu.v1.SetExerciseWorkstreamResponse");
_define_property(SetExerciseWorkstreamResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "body",
            kind: "message",
            T: SetExerciseWorkstreamResponse$1
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.SetDutyAssignmentRequest
 */ export class SetDutyAssignmentRequest extends Message {
    static fromBinary(bytes, options) {
        return new SetDutyAssignmentRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new SetDutyAssignmentRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new SetDutyAssignmentRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(SetDutyAssignmentRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.SetDutyAssignmentRequest body = 1;
   */ _define_property(this, "body", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(SetDutyAssignmentRequest, "runtime", proto3);
_define_property(SetDutyAssignmentRequest, "typeName", "mono.ryugu.v1.SetDutyAssignmentRequest");
_define_property(SetDutyAssignmentRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "body",
            kind: "message",
            T: SetDutyAssignmentRequest$1
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.SetDutyAssignmentResponse
 */ export class SetDutyAssignmentResponse extends Message {
    static fromBinary(bytes, options) {
        return new SetDutyAssignmentResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new SetDutyAssignmentResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new SetDutyAssignmentResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(SetDutyAssignmentResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.SetDutyAssignmentResponse body = 1;
   */ _define_property(this, "body", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(SetDutyAssignmentResponse, "runtime", proto3);
_define_property(SetDutyAssignmentResponse, "typeName", "mono.ryugu.v1.SetDutyAssignmentResponse");
_define_property(SetDutyAssignmentResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "body",
            kind: "message",
            T: SetDutyAssignmentResponse$1
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.RuleSowGapRequest
 */ export class RuleSowGapRequest extends Message {
    static fromBinary(bytes, options) {
        return new RuleSowGapRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new RuleSowGapRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new RuleSowGapRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(RuleSowGapRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.RuleSowGapRequest body = 1;
   */ _define_property(this, "body", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(RuleSowGapRequest, "runtime", proto3);
_define_property(RuleSowGapRequest, "typeName", "mono.ryugu.v1.RuleSowGapRequest");
_define_property(RuleSowGapRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "body",
            kind: "message",
            T: RuleSowGapRequest$1
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.RuleSowGapResponse
 */ export class RuleSowGapResponse extends Message {
    static fromBinary(bytes, options) {
        return new RuleSowGapResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new RuleSowGapResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new RuleSowGapResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(RuleSowGapResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.RuleSowGapResponse body = 1;
   */ _define_property(this, "body", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(RuleSowGapResponse, "runtime", proto3);
_define_property(RuleSowGapResponse, "typeName", "mono.ryugu.v1.RuleSowGapResponse");
_define_property(RuleSowGapResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "body",
            kind: "message",
            T: RuleSowGapResponse$1
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.CreateSubmissionRequest
 */ export class CreateSubmissionRequest extends Message {
    static fromBinary(bytes, options) {
        return new CreateSubmissionRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CreateSubmissionRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CreateSubmissionRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CreateSubmissionRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.CreateSubmissionRequest body = 1;
   */ _define_property(this, "body", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(CreateSubmissionRequest, "runtime", proto3);
_define_property(CreateSubmissionRequest, "typeName", "mono.ryugu.v1.CreateSubmissionRequest");
_define_property(CreateSubmissionRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "body",
            kind: "message",
            T: CreateSubmissionRequest$1
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.CreateSubmissionResponse
 */ export class CreateSubmissionResponse extends Message {
    static fromBinary(bytes, options) {
        return new CreateSubmissionResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CreateSubmissionResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CreateSubmissionResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CreateSubmissionResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.CreateSubmissionResponse body = 1;
   */ _define_property(this, "body", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(CreateSubmissionResponse, "runtime", proto3);
_define_property(CreateSubmissionResponse, "typeName", "mono.ryugu.v1.CreateSubmissionResponse");
_define_property(CreateSubmissionResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "body",
            kind: "message",
            T: CreateSubmissionResponse$1
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.UpdateSubmissionRequest
 */ export class UpdateSubmissionRequest extends Message {
    static fromBinary(bytes, options) {
        return new UpdateSubmissionRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UpdateSubmissionRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UpdateSubmissionRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UpdateSubmissionRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.UpdateSubmissionRequest body = 1;
   */ _define_property(this, "body", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(UpdateSubmissionRequest, "runtime", proto3);
_define_property(UpdateSubmissionRequest, "typeName", "mono.ryugu.v1.UpdateSubmissionRequest");
_define_property(UpdateSubmissionRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "body",
            kind: "message",
            T: UpdateSubmissionRequest$1
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.UpdateSubmissionResponse
 */ export class UpdateSubmissionResponse extends Message {
    static fromBinary(bytes, options) {
        return new UpdateSubmissionResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UpdateSubmissionResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UpdateSubmissionResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UpdateSubmissionResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.UpdateSubmissionResponse body = 1;
   */ _define_property(this, "body", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(UpdateSubmissionResponse, "runtime", proto3);
_define_property(UpdateSubmissionResponse, "typeName", "mono.ryugu.v1.UpdateSubmissionResponse");
_define_property(UpdateSubmissionResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "body",
            kind: "message",
            T: UpdateSubmissionResponse$1
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.WithdrawSubmissionRequest
 */ export class WithdrawSubmissionRequest extends Message {
    static fromBinary(bytes, options) {
        return new WithdrawSubmissionRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new WithdrawSubmissionRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new WithdrawSubmissionRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(WithdrawSubmissionRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.WithdrawSubmissionRequest body = 1;
   */ _define_property(this, "body", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(WithdrawSubmissionRequest, "runtime", proto3);
_define_property(WithdrawSubmissionRequest, "typeName", "mono.ryugu.v1.WithdrawSubmissionRequest");
_define_property(WithdrawSubmissionRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "body",
            kind: "message",
            T: WithdrawSubmissionRequest$1
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.WithdrawSubmissionResponse
 */ export class WithdrawSubmissionResponse extends Message {
    static fromBinary(bytes, options) {
        return new WithdrawSubmissionResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new WithdrawSubmissionResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new WithdrawSubmissionResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(WithdrawSubmissionResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.WithdrawSubmissionResponse body = 1;
   */ _define_property(this, "body", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(WithdrawSubmissionResponse, "runtime", proto3);
_define_property(WithdrawSubmissionResponse, "typeName", "mono.ryugu.v1.WithdrawSubmissionResponse");
_define_property(WithdrawSubmissionResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "body",
            kind: "message",
            T: WithdrawSubmissionResponse$1
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.RecordReviewRequest
 */ export class RecordReviewRequest extends Message {
    static fromBinary(bytes, options) {
        return new RecordReviewRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new RecordReviewRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new RecordReviewRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(RecordReviewRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.RecordReviewRequest body = 1;
   */ _define_property(this, "body", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(RecordReviewRequest, "runtime", proto3);
_define_property(RecordReviewRequest, "typeName", "mono.ryugu.v1.RecordReviewRequest");
_define_property(RecordReviewRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "body",
            kind: "message",
            T: RecordReviewRequest$1
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.RecordReviewResponse
 */ export class RecordReviewResponse extends Message {
    static fromBinary(bytes, options) {
        return new RecordReviewResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new RecordReviewResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new RecordReviewResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(RecordReviewResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.RecordReviewResponse body = 1;
   */ _define_property(this, "body", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(RecordReviewResponse, "runtime", proto3);
_define_property(RecordReviewResponse, "typeName", "mono.ryugu.v1.RecordReviewResponse");
_define_property(RecordReviewResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "body",
            kind: "message",
            T: RecordReviewResponse$1
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.ApplyEvidenceBatchRequest
 */ export class ApplyEvidenceBatchRequest extends Message {
    static fromBinary(bytes, options) {
        return new ApplyEvidenceBatchRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ApplyEvidenceBatchRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ApplyEvidenceBatchRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ApplyEvidenceBatchRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.ApplyEvidenceBatchRequest body = 1;
   */ _define_property(this, "body", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ApplyEvidenceBatchRequest, "runtime", proto3);
_define_property(ApplyEvidenceBatchRequest, "typeName", "mono.ryugu.v1.ApplyEvidenceBatchRequest");
_define_property(ApplyEvidenceBatchRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "body",
            kind: "message",
            T: ApplyEvidenceBatchRequest$1
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.ApplyEvidenceBatchResponse
 */ export class ApplyEvidenceBatchResponse extends Message {
    static fromBinary(bytes, options) {
        return new ApplyEvidenceBatchResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ApplyEvidenceBatchResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ApplyEvidenceBatchResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ApplyEvidenceBatchResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.ApplyEvidenceBatchResponse body = 1;
   */ _define_property(this, "body", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ApplyEvidenceBatchResponse, "runtime", proto3);
_define_property(ApplyEvidenceBatchResponse, "typeName", "mono.ryugu.v1.ApplyEvidenceBatchResponse");
_define_property(ApplyEvidenceBatchResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "body",
            kind: "message",
            T: ApplyEvidenceBatchResponse$1
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.GetDeliverableSettingsRequest
 */ export class GetDeliverableSettingsRequest extends Message {
    static fromBinary(bytes, options) {
        return new GetDeliverableSettingsRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetDeliverableSettingsRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetDeliverableSettingsRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetDeliverableSettingsRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.GetDeliverableSettingsRequest body = 1;
   */ _define_property(this, "body", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetDeliverableSettingsRequest, "runtime", proto3);
_define_property(GetDeliverableSettingsRequest, "typeName", "mono.ryugu.v1.GetDeliverableSettingsRequest");
_define_property(GetDeliverableSettingsRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "body",
            kind: "message",
            T: GetDeliverableSettingsRequest$1
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.GetDeliverableSettingsResponse
 */ export class GetDeliverableSettingsResponse extends Message {
    static fromBinary(bytes, options) {
        return new GetDeliverableSettingsResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetDeliverableSettingsResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetDeliverableSettingsResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetDeliverableSettingsResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.GetDeliverableSettingsResponse body = 1;
   */ _define_property(this, "body", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetDeliverableSettingsResponse, "runtime", proto3);
_define_property(GetDeliverableSettingsResponse, "typeName", "mono.ryugu.v1.GetDeliverableSettingsResponse");
_define_property(GetDeliverableSettingsResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "body",
            kind: "message",
            T: GetDeliverableSettingsResponse$1
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.UpdateDeliverableSettingsRequest
 */ export class UpdateDeliverableSettingsRequest extends Message {
    static fromBinary(bytes, options) {
        return new UpdateDeliverableSettingsRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UpdateDeliverableSettingsRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UpdateDeliverableSettingsRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UpdateDeliverableSettingsRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.UpdateDeliverableSettingsRequest body = 1;
   */ _define_property(this, "body", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(UpdateDeliverableSettingsRequest, "runtime", proto3);
_define_property(UpdateDeliverableSettingsRequest, "typeName", "mono.ryugu.v1.UpdateDeliverableSettingsRequest");
_define_property(UpdateDeliverableSettingsRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "body",
            kind: "message",
            T: UpdateDeliverableSettingsRequest$1
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.UpdateDeliverableSettingsResponse
 */ export class UpdateDeliverableSettingsResponse extends Message {
    static fromBinary(bytes, options) {
        return new UpdateDeliverableSettingsResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UpdateDeliverableSettingsResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UpdateDeliverableSettingsResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UpdateDeliverableSettingsResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.UpdateDeliverableSettingsResponse body = 1;
   */ _define_property(this, "body", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(UpdateDeliverableSettingsResponse, "runtime", proto3);
_define_property(UpdateDeliverableSettingsResponse, "typeName", "mono.ryugu.v1.UpdateDeliverableSettingsResponse");
_define_property(UpdateDeliverableSettingsResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "body",
            kind: "message",
            T: UpdateDeliverableSettingsResponse$1
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.GetProgramGlossaryRequest
 */ export class GetProgramGlossaryRequest extends Message {
    static fromBinary(bytes, options) {
        return new GetProgramGlossaryRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetProgramGlossaryRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetProgramGlossaryRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetProgramGlossaryRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.GetProgramGlossaryRequest body = 1;
   */ _define_property(this, "body", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetProgramGlossaryRequest, "runtime", proto3);
_define_property(GetProgramGlossaryRequest, "typeName", "mono.ryugu.v1.GetProgramGlossaryRequest");
_define_property(GetProgramGlossaryRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "body",
            kind: "message",
            T: GetProgramGlossaryRequest$1
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.GetProgramGlossaryResponse
 */ export class GetProgramGlossaryResponse extends Message {
    static fromBinary(bytes, options) {
        return new GetProgramGlossaryResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetProgramGlossaryResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetProgramGlossaryResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetProgramGlossaryResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.GetProgramGlossaryResponse body = 1;
   */ _define_property(this, "body", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetProgramGlossaryResponse, "runtime", proto3);
_define_property(GetProgramGlossaryResponse, "typeName", "mono.ryugu.v1.GetProgramGlossaryResponse");
_define_property(GetProgramGlossaryResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "body",
            kind: "message",
            T: GetProgramGlossaryResponse$1
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.RekindGlossaryTermRequest
 */ export class RekindGlossaryTermRequest extends Message {
    static fromBinary(bytes, options) {
        return new RekindGlossaryTermRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new RekindGlossaryTermRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new RekindGlossaryTermRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(RekindGlossaryTermRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.RekindGlossaryTermRequest body = 1;
   */ _define_property(this, "body", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(RekindGlossaryTermRequest, "runtime", proto3);
_define_property(RekindGlossaryTermRequest, "typeName", "mono.ryugu.v1.RekindGlossaryTermRequest");
_define_property(RekindGlossaryTermRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "body",
            kind: "message",
            T: RekindGlossaryTermRequest$1
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.RekindGlossaryTermResponse
 */ export class RekindGlossaryTermResponse extends Message {
    static fromBinary(bytes, options) {
        return new RekindGlossaryTermResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new RekindGlossaryTermResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new RekindGlossaryTermResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(RekindGlossaryTermResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.RekindGlossaryTermResponse body = 1;
   */ _define_property(this, "body", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(RekindGlossaryTermResponse, "runtime", proto3);
_define_property(RekindGlossaryTermResponse, "typeName", "mono.ryugu.v1.RekindGlossaryTermResponse");
_define_property(RekindGlossaryTermResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "body",
            kind: "message",
            T: RekindGlossaryTermResponse$1
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.RejectGlossaryTermRequest
 */ export class RejectGlossaryTermRequest extends Message {
    static fromBinary(bytes, options) {
        return new RejectGlossaryTermRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new RejectGlossaryTermRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new RejectGlossaryTermRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(RejectGlossaryTermRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.RejectGlossaryTermRequest body = 1;
   */ _define_property(this, "body", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(RejectGlossaryTermRequest, "runtime", proto3);
_define_property(RejectGlossaryTermRequest, "typeName", "mono.ryugu.v1.RejectGlossaryTermRequest");
_define_property(RejectGlossaryTermRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "body",
            kind: "message",
            T: RejectGlossaryTermRequest$1
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.RejectGlossaryTermResponse
 */ export class RejectGlossaryTermResponse extends Message {
    static fromBinary(bytes, options) {
        return new RejectGlossaryTermResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new RejectGlossaryTermResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new RejectGlossaryTermResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(RejectGlossaryTermResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.RejectGlossaryTermResponse body = 1;
   */ _define_property(this, "body", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(RejectGlossaryTermResponse, "runtime", proto3);
_define_property(RejectGlossaryTermResponse, "typeName", "mono.ryugu.v1.RejectGlossaryTermResponse");
_define_property(RejectGlossaryTermResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "body",
            kind: "message",
            T: RejectGlossaryTermResponse$1
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.RejectGlossaryRelationRequest
 */ export class RejectGlossaryRelationRequest extends Message {
    static fromBinary(bytes, options) {
        return new RejectGlossaryRelationRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new RejectGlossaryRelationRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new RejectGlossaryRelationRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(RejectGlossaryRelationRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.RejectGlossaryRelationRequest body = 1;
   */ _define_property(this, "body", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(RejectGlossaryRelationRequest, "runtime", proto3);
_define_property(RejectGlossaryRelationRequest, "typeName", "mono.ryugu.v1.RejectGlossaryRelationRequest");
_define_property(RejectGlossaryRelationRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "body",
            kind: "message",
            T: RejectGlossaryRelationRequest$1
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.RejectGlossaryRelationResponse
 */ export class RejectGlossaryRelationResponse extends Message {
    static fromBinary(bytes, options) {
        return new RejectGlossaryRelationResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new RejectGlossaryRelationResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new RejectGlossaryRelationResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(RejectGlossaryRelationResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.RejectGlossaryRelationResponse body = 1;
   */ _define_property(this, "body", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(RejectGlossaryRelationResponse, "runtime", proto3);
_define_property(RejectGlossaryRelationResponse, "typeName", "mono.ryugu.v1.RejectGlossaryRelationResponse");
_define_property(RejectGlossaryRelationResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "body",
            kind: "message",
            T: RejectGlossaryRelationResponse$1
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.AddGlossaryRelationRequest
 */ export class AddGlossaryRelationRequest extends Message {
    static fromBinary(bytes, options) {
        return new AddGlossaryRelationRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new AddGlossaryRelationRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new AddGlossaryRelationRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(AddGlossaryRelationRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.AddGlossaryRelationRequest body = 1;
   */ _define_property(this, "body", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(AddGlossaryRelationRequest, "runtime", proto3);
_define_property(AddGlossaryRelationRequest, "typeName", "mono.ryugu.v1.AddGlossaryRelationRequest");
_define_property(AddGlossaryRelationRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "body",
            kind: "message",
            T: AddGlossaryRelationRequest$1
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.AddGlossaryRelationResponse
 */ export class AddGlossaryRelationResponse extends Message {
    static fromBinary(bytes, options) {
        return new AddGlossaryRelationResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new AddGlossaryRelationResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new AddGlossaryRelationResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(AddGlossaryRelationResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.AddGlossaryRelationResponse body = 1;
   */ _define_property(this, "body", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(AddGlossaryRelationResponse, "runtime", proto3);
_define_property(AddGlossaryRelationResponse, "typeName", "mono.ryugu.v1.AddGlossaryRelationResponse");
_define_property(AddGlossaryRelationResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "body",
            kind: "message",
            T: AddGlossaryRelationResponse$1
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.BindGlossaryTermRequest
 */ export class BindGlossaryTermRequest extends Message {
    static fromBinary(bytes, options) {
        return new BindGlossaryTermRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new BindGlossaryTermRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new BindGlossaryTermRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(BindGlossaryTermRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.BindGlossaryTermRequest body = 1;
   */ _define_property(this, "body", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(BindGlossaryTermRequest, "runtime", proto3);
_define_property(BindGlossaryTermRequest, "typeName", "mono.ryugu.v1.BindGlossaryTermRequest");
_define_property(BindGlossaryTermRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "body",
            kind: "message",
            T: BindGlossaryTermRequest$1
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.BindGlossaryTermResponse
 */ export class BindGlossaryTermResponse extends Message {
    static fromBinary(bytes, options) {
        return new BindGlossaryTermResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new BindGlossaryTermResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new BindGlossaryTermResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(BindGlossaryTermResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.BindGlossaryTermResponse body = 1;
   */ _define_property(this, "body", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(BindGlossaryTermResponse, "runtime", proto3);
_define_property(BindGlossaryTermResponse, "typeName", "mono.ryugu.v1.BindGlossaryTermResponse");
_define_property(BindGlossaryTermResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "body",
            kind: "message",
            T: BindGlossaryTermResponse$1
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.ListWorkstreamMembersRequest
 */ export class ListWorkstreamMembersRequest extends Message {
    static fromBinary(bytes, options) {
        return new ListWorkstreamMembersRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListWorkstreamMembersRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListWorkstreamMembersRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListWorkstreamMembersRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.ListWorkstreamMembersRequest body = 1;
   */ _define_property(this, "body", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListWorkstreamMembersRequest, "runtime", proto3);
_define_property(ListWorkstreamMembersRequest, "typeName", "mono.ryugu.v1.ListWorkstreamMembersRequest");
_define_property(ListWorkstreamMembersRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "body",
            kind: "message",
            T: ListWorkstreamMembersRequest$1
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.ListWorkstreamMembersResponse
 */ export class ListWorkstreamMembersResponse extends Message {
    static fromBinary(bytes, options) {
        return new ListWorkstreamMembersResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListWorkstreamMembersResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListWorkstreamMembersResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListWorkstreamMembersResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.ListWorkstreamMembersResponse body = 1;
   */ _define_property(this, "body", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListWorkstreamMembersResponse, "runtime", proto3);
_define_property(ListWorkstreamMembersResponse, "typeName", "mono.ryugu.v1.ListWorkstreamMembersResponse");
_define_property(ListWorkstreamMembersResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "body",
            kind: "message",
            T: ListWorkstreamMembersResponse$1
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.AddWorkstreamMemberRequest
 */ export class AddWorkstreamMemberRequest extends Message {
    static fromBinary(bytes, options) {
        return new AddWorkstreamMemberRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new AddWorkstreamMemberRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new AddWorkstreamMemberRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(AddWorkstreamMemberRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.AddWorkstreamMemberRequest body = 1;
   */ _define_property(this, "body", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(AddWorkstreamMemberRequest, "runtime", proto3);
_define_property(AddWorkstreamMemberRequest, "typeName", "mono.ryugu.v1.AddWorkstreamMemberRequest");
_define_property(AddWorkstreamMemberRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "body",
            kind: "message",
            T: AddWorkstreamMemberRequest$1
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.AddWorkstreamMemberResponse
 */ export class AddWorkstreamMemberResponse extends Message {
    static fromBinary(bytes, options) {
        return new AddWorkstreamMemberResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new AddWorkstreamMemberResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new AddWorkstreamMemberResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(AddWorkstreamMemberResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.AddWorkstreamMemberResponse body = 1;
   */ _define_property(this, "body", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(AddWorkstreamMemberResponse, "runtime", proto3);
_define_property(AddWorkstreamMemberResponse, "typeName", "mono.ryugu.v1.AddWorkstreamMemberResponse");
_define_property(AddWorkstreamMemberResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "body",
            kind: "message",
            T: AddWorkstreamMemberResponse$1
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.UpdateWorkstreamMemberRequest
 */ export class UpdateWorkstreamMemberRequest extends Message {
    static fromBinary(bytes, options) {
        return new UpdateWorkstreamMemberRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UpdateWorkstreamMemberRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UpdateWorkstreamMemberRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UpdateWorkstreamMemberRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.UpdateWorkstreamMemberRequest body = 1;
   */ _define_property(this, "body", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(UpdateWorkstreamMemberRequest, "runtime", proto3);
_define_property(UpdateWorkstreamMemberRequest, "typeName", "mono.ryugu.v1.UpdateWorkstreamMemberRequest");
_define_property(UpdateWorkstreamMemberRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "body",
            kind: "message",
            T: UpdateWorkstreamMemberRequest$1
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.UpdateWorkstreamMemberResponse
 */ export class UpdateWorkstreamMemberResponse extends Message {
    static fromBinary(bytes, options) {
        return new UpdateWorkstreamMemberResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UpdateWorkstreamMemberResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UpdateWorkstreamMemberResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UpdateWorkstreamMemberResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.UpdateWorkstreamMemberResponse body = 1;
   */ _define_property(this, "body", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(UpdateWorkstreamMemberResponse, "runtime", proto3);
_define_property(UpdateWorkstreamMemberResponse, "typeName", "mono.ryugu.v1.UpdateWorkstreamMemberResponse");
_define_property(UpdateWorkstreamMemberResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "body",
            kind: "message",
            T: UpdateWorkstreamMemberResponse$1
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.RemoveWorkstreamMemberRequest
 */ export class RemoveWorkstreamMemberRequest extends Message {
    static fromBinary(bytes, options) {
        return new RemoveWorkstreamMemberRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new RemoveWorkstreamMemberRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new RemoveWorkstreamMemberRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(RemoveWorkstreamMemberRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.RemoveWorkstreamMemberRequest body = 1;
   */ _define_property(this, "body", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(RemoveWorkstreamMemberRequest, "runtime", proto3);
_define_property(RemoveWorkstreamMemberRequest, "typeName", "mono.ryugu.v1.RemoveWorkstreamMemberRequest");
_define_property(RemoveWorkstreamMemberRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "body",
            kind: "message",
            T: RemoveWorkstreamMemberRequest$1
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.RemoveWorkstreamMemberResponse
 */ export class RemoveWorkstreamMemberResponse extends Message {
    static fromBinary(bytes, options) {
        return new RemoveWorkstreamMemberResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new RemoveWorkstreamMemberResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new RemoveWorkstreamMemberResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(RemoveWorkstreamMemberResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.RemoveWorkstreamMemberResponse body = 1;
   */ _define_property(this, "body", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(RemoveWorkstreamMemberResponse, "runtime", proto3);
_define_property(RemoveWorkstreamMemberResponse, "typeName", "mono.ryugu.v1.RemoveWorkstreamMemberResponse");
_define_property(RemoveWorkstreamMemberResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "body",
            kind: "message",
            T: RemoveWorkstreamMemberResponse$1
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.CreateWorkProductRequest
 */ export class CreateWorkProductRequest extends Message {
    static fromBinary(bytes, options) {
        return new CreateWorkProductRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CreateWorkProductRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CreateWorkProductRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CreateWorkProductRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.CreateWorkProductRequest body = 1;
   */ _define_property(this, "body", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(CreateWorkProductRequest, "runtime", proto3);
_define_property(CreateWorkProductRequest, "typeName", "mono.ryugu.v1.CreateWorkProductRequest");
_define_property(CreateWorkProductRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "body",
            kind: "message",
            T: CreateWorkProductRequest$1
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.CreateWorkProductResponse
 */ export class CreateWorkProductResponse extends Message {
    static fromBinary(bytes, options) {
        return new CreateWorkProductResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CreateWorkProductResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CreateWorkProductResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CreateWorkProductResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.CreateWorkProductResponse body = 1;
   */ _define_property(this, "body", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(CreateWorkProductResponse, "runtime", proto3);
_define_property(CreateWorkProductResponse, "typeName", "mono.ryugu.v1.CreateWorkProductResponse");
_define_property(CreateWorkProductResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "body",
            kind: "message",
            T: CreateWorkProductResponse$1
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.UpdateWorkProductRequest
 */ export class UpdateWorkProductRequest extends Message {
    static fromBinary(bytes, options) {
        return new UpdateWorkProductRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UpdateWorkProductRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UpdateWorkProductRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UpdateWorkProductRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.UpdateWorkProductRequest body = 1;
   */ _define_property(this, "body", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(UpdateWorkProductRequest, "runtime", proto3);
_define_property(UpdateWorkProductRequest, "typeName", "mono.ryugu.v1.UpdateWorkProductRequest");
_define_property(UpdateWorkProductRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "body",
            kind: "message",
            T: UpdateWorkProductRequest$1
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.UpdateWorkProductResponse
 */ export class UpdateWorkProductResponse extends Message {
    static fromBinary(bytes, options) {
        return new UpdateWorkProductResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UpdateWorkProductResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UpdateWorkProductResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UpdateWorkProductResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.UpdateWorkProductResponse body = 1;
   */ _define_property(this, "body", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(UpdateWorkProductResponse, "runtime", proto3);
_define_property(UpdateWorkProductResponse, "typeName", "mono.ryugu.v1.UpdateWorkProductResponse");
_define_property(UpdateWorkProductResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "body",
            kind: "message",
            T: UpdateWorkProductResponse$1
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.ListWorkProductsRequest
 */ export class ListWorkProductsRequest extends Message {
    static fromBinary(bytes, options) {
        return new ListWorkProductsRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListWorkProductsRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListWorkProductsRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListWorkProductsRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.ListWorkProductsRequest body = 1;
   */ _define_property(this, "body", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListWorkProductsRequest, "runtime", proto3);
_define_property(ListWorkProductsRequest, "typeName", "mono.ryugu.v1.ListWorkProductsRequest");
_define_property(ListWorkProductsRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "body",
            kind: "message",
            T: ListWorkProductsRequest$1
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.ListWorkProductsResponse
 */ export class ListWorkProductsResponse extends Message {
    static fromBinary(bytes, options) {
        return new ListWorkProductsResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListWorkProductsResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListWorkProductsResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListWorkProductsResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.ListWorkProductsResponse body = 1;
   */ _define_property(this, "body", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListWorkProductsResponse, "runtime", proto3);
_define_property(ListWorkProductsResponse, "typeName", "mono.ryugu.v1.ListWorkProductsResponse");
_define_property(ListWorkProductsResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "body",
            kind: "message",
            T: ListWorkProductsResponse$1
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.AssessWorkProductsRequest
 */ export class AssessWorkProductsRequest extends Message {
    static fromBinary(bytes, options) {
        return new AssessWorkProductsRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new AssessWorkProductsRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new AssessWorkProductsRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(AssessWorkProductsRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.AssessWorkProductsRequest body = 1;
   */ _define_property(this, "body", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(AssessWorkProductsRequest, "runtime", proto3);
_define_property(AssessWorkProductsRequest, "typeName", "mono.ryugu.v1.AssessWorkProductsRequest");
_define_property(AssessWorkProductsRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "body",
            kind: "message",
            T: AssessWorkProductsRequest$1
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.AssessWorkProductsResponse
 */ export class AssessWorkProductsResponse extends Message {
    static fromBinary(bytes, options) {
        return new AssessWorkProductsResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new AssessWorkProductsResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new AssessWorkProductsResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(AssessWorkProductsResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.AssessWorkProductsResponse body = 1;
   */ _define_property(this, "body", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(AssessWorkProductsResponse, "runtime", proto3);
_define_property(AssessWorkProductsResponse, "typeName", "mono.ryugu.v1.AssessWorkProductsResponse");
_define_property(AssessWorkProductsResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "body",
            kind: "message",
            T: AssessWorkProductsResponse$1
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.PromoteWorkProductRequest
 */ export class PromoteWorkProductRequest extends Message {
    static fromBinary(bytes, options) {
        return new PromoteWorkProductRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new PromoteWorkProductRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new PromoteWorkProductRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(PromoteWorkProductRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.PromoteWorkProductRequest body = 1;
   */ _define_property(this, "body", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(PromoteWorkProductRequest, "runtime", proto3);
_define_property(PromoteWorkProductRequest, "typeName", "mono.ryugu.v1.PromoteWorkProductRequest");
_define_property(PromoteWorkProductRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "body",
            kind: "message",
            T: PromoteWorkProductRequest$1
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.PromoteWorkProductResponse
 */ export class PromoteWorkProductResponse extends Message {
    static fromBinary(bytes, options) {
        return new PromoteWorkProductResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new PromoteWorkProductResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new PromoteWorkProductResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(PromoteWorkProductResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.PromoteWorkProductResponse body = 1;
   */ _define_property(this, "body", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(PromoteWorkProductResponse, "runtime", proto3);
_define_property(PromoteWorkProductResponse, "typeName", "mono.ryugu.v1.PromoteWorkProductResponse");
_define_property(PromoteWorkProductResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "body",
            kind: "message",
            T: PromoteWorkProductResponse$1
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.FindWorkProductDuplicatesRequest
 */ export class FindWorkProductDuplicatesRequest extends Message {
    static fromBinary(bytes, options) {
        return new FindWorkProductDuplicatesRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new FindWorkProductDuplicatesRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new FindWorkProductDuplicatesRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(FindWorkProductDuplicatesRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.FindWorkProductDuplicatesRequest body = 1;
   */ _define_property(this, "body", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(FindWorkProductDuplicatesRequest, "runtime", proto3);
_define_property(FindWorkProductDuplicatesRequest, "typeName", "mono.ryugu.v1.FindWorkProductDuplicatesRequest");
_define_property(FindWorkProductDuplicatesRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "body",
            kind: "message",
            T: FindWorkProductDuplicatesRequest$1
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.FindWorkProductDuplicatesResponse
 */ export class FindWorkProductDuplicatesResponse extends Message {
    static fromBinary(bytes, options) {
        return new FindWorkProductDuplicatesResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new FindWorkProductDuplicatesResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new FindWorkProductDuplicatesResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(FindWorkProductDuplicatesResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.FindWorkProductDuplicatesResponse body = 1;
   */ _define_property(this, "body", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(FindWorkProductDuplicatesResponse, "runtime", proto3);
_define_property(FindWorkProductDuplicatesResponse, "typeName", "mono.ryugu.v1.FindWorkProductDuplicatesResponse");
_define_property(FindWorkProductDuplicatesResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "body",
            kind: "message",
            T: FindWorkProductDuplicatesResponse$1
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.ListCommentsRequest
 */ export class ListCommentsRequest extends Message {
    static fromBinary(bytes, options) {
        return new ListCommentsRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListCommentsRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListCommentsRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListCommentsRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.ListCommentsRequest body = 1;
   */ _define_property(this, "body", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListCommentsRequest, "runtime", proto3);
_define_property(ListCommentsRequest, "typeName", "mono.ryugu.v1.ListCommentsRequest");
_define_property(ListCommentsRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "body",
            kind: "message",
            T: ListCommentsRequest$1
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.ListCommentsResponse
 */ export class ListCommentsResponse extends Message {
    static fromBinary(bytes, options) {
        return new ListCommentsResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListCommentsResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListCommentsResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListCommentsResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.ListCommentsResponse body = 1;
   */ _define_property(this, "body", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListCommentsResponse, "runtime", proto3);
_define_property(ListCommentsResponse, "typeName", "mono.ryugu.v1.ListCommentsResponse");
_define_property(ListCommentsResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "body",
            kind: "message",
            T: ListCommentsResponse$1
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.CreateCommentRequest
 */ export class CreateCommentRequest extends Message {
    static fromBinary(bytes, options) {
        return new CreateCommentRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CreateCommentRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CreateCommentRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CreateCommentRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.CreateCommentRequest body = 1;
   */ _define_property(this, "body", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(CreateCommentRequest, "runtime", proto3);
_define_property(CreateCommentRequest, "typeName", "mono.ryugu.v1.CreateCommentRequest");
_define_property(CreateCommentRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "body",
            kind: "message",
            T: CreateCommentRequest$1
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.CreateCommentResponse
 */ export class CreateCommentResponse extends Message {
    static fromBinary(bytes, options) {
        return new CreateCommentResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CreateCommentResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CreateCommentResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CreateCommentResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.CreateCommentResponse body = 1;
   */ _define_property(this, "body", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(CreateCommentResponse, "runtime", proto3);
_define_property(CreateCommentResponse, "typeName", "mono.ryugu.v1.CreateCommentResponse");
_define_property(CreateCommentResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "body",
            kind: "message",
            T: CreateCommentResponse$1
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.UpdateCommentRequest
 */ export class UpdateCommentRequest extends Message {
    static fromBinary(bytes, options) {
        return new UpdateCommentRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UpdateCommentRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UpdateCommentRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UpdateCommentRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.UpdateCommentRequest body = 1;
   */ _define_property(this, "body", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(UpdateCommentRequest, "runtime", proto3);
_define_property(UpdateCommentRequest, "typeName", "mono.ryugu.v1.UpdateCommentRequest");
_define_property(UpdateCommentRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "body",
            kind: "message",
            T: UpdateCommentRequest$1
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.UpdateCommentResponse
 */ export class UpdateCommentResponse extends Message {
    static fromBinary(bytes, options) {
        return new UpdateCommentResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UpdateCommentResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UpdateCommentResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UpdateCommentResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.UpdateCommentResponse body = 1;
   */ _define_property(this, "body", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(UpdateCommentResponse, "runtime", proto3);
_define_property(UpdateCommentResponse, "typeName", "mono.ryugu.v1.UpdateCommentResponse");
_define_property(UpdateCommentResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "body",
            kind: "message",
            T: UpdateCommentResponse$1
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.DeleteCommentRequest
 */ export class DeleteCommentRequest extends Message {
    static fromBinary(bytes, options) {
        return new DeleteCommentRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new DeleteCommentRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new DeleteCommentRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(DeleteCommentRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.DeleteCommentRequest body = 1;
   */ _define_property(this, "body", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(DeleteCommentRequest, "runtime", proto3);
_define_property(DeleteCommentRequest, "typeName", "mono.ryugu.v1.DeleteCommentRequest");
_define_property(DeleteCommentRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "body",
            kind: "message",
            T: DeleteCommentRequest$1
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.DeleteCommentResponse
 */ export class DeleteCommentResponse extends Message {
    static fromBinary(bytes, options) {
        return new DeleteCommentResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new DeleteCommentResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new DeleteCommentResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(DeleteCommentResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.DeleteCommentResponse body = 1;
   */ _define_property(this, "body", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(DeleteCommentResponse, "runtime", proto3);
_define_property(DeleteCommentResponse, "typeName", "mono.ryugu.v1.DeleteCommentResponse");
_define_property(DeleteCommentResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "body",
            kind: "message",
            T: DeleteCommentResponse$1
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.SetCommentUpvoteRequest
 */ export class SetCommentUpvoteRequest extends Message {
    static fromBinary(bytes, options) {
        return new SetCommentUpvoteRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new SetCommentUpvoteRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new SetCommentUpvoteRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(SetCommentUpvoteRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.SetCommentUpvoteRequest body = 1;
   */ _define_property(this, "body", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(SetCommentUpvoteRequest, "runtime", proto3);
_define_property(SetCommentUpvoteRequest, "typeName", "mono.ryugu.v1.SetCommentUpvoteRequest");
_define_property(SetCommentUpvoteRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "body",
            kind: "message",
            T: SetCommentUpvoteRequest$1
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.SetCommentUpvoteResponse
 */ export class SetCommentUpvoteResponse extends Message {
    static fromBinary(bytes, options) {
        return new SetCommentUpvoteResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new SetCommentUpvoteResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new SetCommentUpvoteResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(SetCommentUpvoteResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.SetCommentUpvoteResponse body = 1;
   */ _define_property(this, "body", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(SetCommentUpvoteResponse, "runtime", proto3);
_define_property(SetCommentUpvoteResponse, "typeName", "mono.ryugu.v1.SetCommentUpvoteResponse");
_define_property(SetCommentUpvoteResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "body",
            kind: "message",
            T: SetCommentUpvoteResponse$1
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.ListMyWorkRequest
 */ export class ListMyWorkRequest extends Message {
    static fromBinary(bytes, options) {
        return new ListMyWorkRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListMyWorkRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListMyWorkRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListMyWorkRequest, a, b);
    }
    constructor(data){
        super(), /**
   * kinds keeps these kinds; empty keeps every kind. The counts are always
   * of every kind.
   *
   * @generated from field: repeated string kinds = 1;
   */ _define_property(this, "kinds", []), /**
   * limit caps the items (0 = 100, at most 300).
   *
   * @generated from field: int32 limit = 2;
   */ _define_property(this, "limit", 0), /**
   * as_of is the day statuses are taken on; "" = today.
   *
   * @generated from field: string as_of = 3;
   */ _define_property(this, "asOf", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListMyWorkRequest, "runtime", proto3);
_define_property(ListMyWorkRequest, "typeName", "mono.ryugu.v1.ListMyWorkRequest");
_define_property(ListMyWorkRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "kinds",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        },
        {
            no: 2,
            name: "limit",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 3,
            name: "as_of",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * MyWorkItem is one thing waiting on the caller. Exactly one source payload
 * is set; kind says which reading of it applies.
 *
 * @generated from message mono.ryugu.v1.MyWorkItem
 */ export class MyWorkItem extends Message {
    static fromBinary(bytes, options) {
        return new MyWorkItem().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new MyWorkItem().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new MyWorkItem().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(MyWorkItem, a, b);
    }
    constructor(data){
        super(), /**
   * kind: late | at_risk | waiting | request (delivery dates and requests,
   * ListAttentionItems owner "me"); correction | issue | risk (assigned
   * actions); decision (a pending go/no-go on a pursuit the caller
   * captures); pursuit_task (a capture task it owns); shared (an item shared
   * with it, SAD-431).
   *
   * @generated from field: string kind = 1;
   */ _define_property(this, "kind", ""), /**
   * key is unique in the list: the kind and the source's id.
   *
   * @generated from field: string key = 2;
   */ _define_property(this, "key", ""), /**
   * rank is the item's place, from 0.
   *
   * @generated from field: int32 rank = 3;
   */ _define_property(this, "rank", 0), /**
   * due_on: the day it is due, "" when none.
   *
   * @generated from field: string due_on = 4;
   */ _define_property(this, "dueOn", ""), /**
   * overdue_days: days past due_on (0 when not past due); a late date's days late.
   *
   * @generated from field: int32 overdue_days = 5;
   */ _define_property(this, "overdueDays", 0), /**
   * @generated from field: mono.datagateway.v1.PortfolioAttentionItem attention = 10;
   */ _define_property(this, "attention", void 0), /**
   * @generated from field: mono.ryugu.v1.MyAssignedAction assigned = 11;
   */ _define_property(this, "assigned", void 0), /**
   * @generated from field: mono.datagateway.v1.MyCaptureDecision decision = 12;
   */ _define_property(this, "decision", void 0), /**
   * @generated from field: mono.datagateway.v1.MyCaptureTask pursuit_task = 13;
   */ _define_property(this, "pursuitTask", void 0), /**
   * @generated from field: mono.datagateway.v1.AttentionItem shared = 14;
   */ _define_property(this, "shared", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(MyWorkItem, "runtime", proto3);
_define_property(MyWorkItem, "typeName", "mono.ryugu.v1.MyWorkItem");
_define_property(MyWorkItem, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "kind",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "key",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "rank",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 4,
            name: "due_on",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "overdue_days",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 10,
            name: "attention",
            kind: "message",
            T: PortfolioAttentionItem
        },
        {
            no: 11,
            name: "assigned",
            kind: "message",
            T: MyAssignedAction
        },
        {
            no: 12,
            name: "decision",
            kind: "message",
            T: MyCaptureDecision
        },
        {
            no: 13,
            name: "pursuit_task",
            kind: "message",
            T: MyCaptureTask
        },
        {
            no: 14,
            name: "shared",
            kind: "message",
            T: AttentionItem
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.MyWorkCount
 */ export class MyWorkCount extends Message {
    static fromBinary(bytes, options) {
        return new MyWorkCount().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new MyWorkCount().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new MyWorkCount().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(MyWorkCount, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string kind = 1;
   */ _define_property(this, "kind", ""), /**
   * @generated from field: int32 count = 2;
   */ _define_property(this, "count", 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(MyWorkCount, "runtime", proto3);
_define_property(MyWorkCount, "typeName", "mono.ryugu.v1.MyWorkCount");
_define_property(MyWorkCount, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "kind",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "count",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.ListMyWorkResponse
 */ export class ListMyWorkResponse extends Message {
    static fromBinary(bytes, options) {
        return new ListMyWorkResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListMyWorkResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListMyWorkResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListMyWorkResponse, a, b);
    }
    constructor(data){
        super(), /**
   * items, ranked: everything past due first, each bucket's most urgent in
   * consequence order (late, overdue, waiting, decision, request, at risk,
   * correction, task, shared), then each bucket's next, and so on.
   *
   * @generated from field: repeated mono.ryugu.v1.MyWorkItem items = 1;
   */ _define_property(this, "items", []), /**
   * counts are every kind's count, before the kinds filter and the limit.
   *
   * @generated from field: repeated mono.ryugu.v1.MyWorkCount counts = 2;
   */ _define_property(this, "counts", []), /**
   * @generated from field: int32 total = 3;
   */ _define_property(this, "total", 0), /**
   * overdue counts every item past due.
   *
   * @generated from field: int32 overdue = 4;
   */ _define_property(this, "overdue", 0), /**
   * @generated from field: string as_of = 5;
   */ _define_property(this, "asOf", ""), /**
   * agenda_days are the next 5 federal working days from as_of.
   *
   * @generated from field: repeated string agenda_days = 6;
   */ _define_property(this, "agendaDays", []), /**
   * partial_kinds name the sources that could not be read (delivery,
   * assigned, pursuits, shared); every other source is complete.
   *
   * @generated from field: repeated string partial_kinds = 7;
   */ _define_property(this, "partialKinds", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListMyWorkResponse, "runtime", proto3);
_define_property(ListMyWorkResponse, "typeName", "mono.ryugu.v1.ListMyWorkResponse");
_define_property(ListMyWorkResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "items",
            kind: "message",
            T: MyWorkItem,
            repeated: true
        },
        {
            no: 2,
            name: "counts",
            kind: "message",
            T: MyWorkCount,
            repeated: true
        },
        {
            no: 3,
            name: "total",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 4,
            name: "overdue",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 5,
            name: "as_of",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "agenda_days",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        },
        {
            no: 7,
            name: "partial_kinds",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.GetPursuitPipelineRequest
 */ export class GetPursuitPipelineRequest extends Message {
    static fromBinary(bytes, options) {
        return new GetPursuitPipelineRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetPursuitPipelineRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetPursuitPipelineRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetPursuitPipelineRequest, a, b);
    }
    constructor(data){
        super(), /**
   * scope: mine (the pursuits the caller is on; with none, every visible
   * one and mine_fallback set) | all.
   *
   * @generated from field: string scope = 1;
   */ _define_property(this, "scope", ""), /**
   * as_of is the day decisions are due against; "" = today.
   *
   * @generated from field: string as_of = 2;
   */ _define_property(this, "asOf", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetPursuitPipelineRequest, "runtime", proto3);
_define_property(GetPursuitPipelineRequest, "typeName", "mono.ryugu.v1.GetPursuitPipelineRequest");
_define_property(GetPursuitPipelineRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "scope",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "as_of",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * PipelineStage is one stage's bar.
 *
 * @generated from message mono.ryugu.v1.PipelineStage
 */ export class PipelineStage extends Message {
    static fromBinary(bytes, options) {
        return new PipelineStage().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new PipelineStage().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new PipelineStage().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(PipelineStage, a, b);
    }
    constructor(data){
        super(), /**
   * stage: shaping | qualifying | pursuing (open) | converted | no_bid
   * (closed in the last 12 months).
   *
   * @generated from field: string stage = 1;
   */ _define_property(this, "stage", ""), /**
   * @generated from field: string label = 2;
   */ _define_property(this, "label", ""), /**
   * @generated from field: bool open = 3;
   */ _define_property(this, "open", false), /**
   * @generated from field: int32 count = 4;
   */ _define_property(this, "count", 0), /**
   * value_count of them have a value that parses; value_total is their sum
   * in whole dollars. Never a guess for the rest.
   *
   * @generated from field: int32 value_count = 5;
   */ _define_property(this, "valueCount", 0), /**
   * @generated from field: int64 value_total = 6;
   */ _define_property(this, "valueTotal", protoInt64.zero);
        proto3.util.initPartial(data, this);
    }
}
_define_property(PipelineStage, "runtime", proto3);
_define_property(PipelineStage, "typeName", "mono.ryugu.v1.PipelineStage");
_define_property(PipelineStage, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "stage",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "label",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "open",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 4,
            name: "count",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 5,
            name: "value_count",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 6,
            name: "value_total",
            kind: "scalar",
            T: 3 /* ScalarType.INT64 */ 
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.GetPursuitPipelineResponse
 */ export class GetPursuitPipelineResponse extends Message {
    static fromBinary(bytes, options) {
        return new GetPursuitPipelineResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetPursuitPipelineResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetPursuitPipelineResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetPursuitPipelineResponse, a, b);
    }
    constructor(data){
        super(), /**
   * has_access: the caller holds capture_project:list on its tenant. Without
   * it nothing else is set.
   *
   * @generated from field: bool has_access = 1;
   */ _define_property(this, "hasAccess", false), /**
   * pursuits is how many pursuits the counts are of (open and closed).
   *
   * @generated from field: int32 pursuits = 2;
   */ _define_property(this, "pursuits", 0), /**
   * @generated from field: repeated mono.ryugu.v1.PipelineStage stages = 3;
   */ _define_property(this, "stages", []), /**
   * @generated from field: int32 open_count = 4;
   */ _define_property(this, "openCount", 0), /**
   * @generated from field: int32 open_value_count = 5;
   */ _define_property(this, "openValueCount", 0), /**
   * @generated from field: int64 open_value_total = 6;
   */ _define_property(this, "openValueTotal", protoInt64.zero), /**
   * decisions_due: pending go/no-go decisions and open capture reviews due
   * within 14 days (past due included), against "none past due".
   *
   * @generated from field: mono.datagateway.v1.KpiReading decisions_due = 7;
   */ _define_property(this, "decisionsDue", void 0), /**
   * @generated from field: bool mine_fallback = 8;
   */ _define_property(this, "mineFallback", false), /**
   * @generated from field: string as_of = 9;
   */ _define_property(this, "asOf", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetPursuitPipelineResponse, "runtime", proto3);
_define_property(GetPursuitPipelineResponse, "typeName", "mono.ryugu.v1.GetPursuitPipelineResponse");
_define_property(GetPursuitPipelineResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "has_access",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 2,
            name: "pursuits",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 3,
            name: "stages",
            kind: "message",
            T: PipelineStage,
            repeated: true
        },
        {
            no: 4,
            name: "open_count",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 5,
            name: "open_value_count",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 6,
            name: "open_value_total",
            kind: "scalar",
            T: 3 /* ScalarType.INT64 */ 
        },
        {
            no: 7,
            name: "decisions_due",
            kind: "message",
            T: KpiReading
        },
        {
            no: 8,
            name: "mine_fallback",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 9,
            name: "as_of",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * Deprecated: ImportTracker's messages, kept in proto only.
 *
 * @generated from message mono.ryugu.v1.ImportTrackerRequest
 * @deprecated
 */ export class ImportTrackerRequest extends Message {
    static fromBinary(bytes, options) {
        return new ImportTrackerRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ImportTrackerRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ImportTrackerRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ImportTrackerRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.ImportTrackerRequest body = 1;
   */ _define_property(this, "body", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ImportTrackerRequest, "runtime", proto3);
_define_property(ImportTrackerRequest, "typeName", "mono.ryugu.v1.ImportTrackerRequest");
_define_property(ImportTrackerRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "body",
            kind: "message",
            T: ImportTrackerRequest$1
        }
    ]));
/**
 * @generated from message mono.ryugu.v1.ImportTrackerResponse
 * @deprecated
 */ export class ImportTrackerResponse extends Message {
    static fromBinary(bytes, options) {
        return new ImportTrackerResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ImportTrackerResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ImportTrackerResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ImportTrackerResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.ImportTrackerResponse body = 1;
   */ _define_property(this, "body", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ImportTrackerResponse, "runtime", proto3);
_define_property(ImportTrackerResponse, "typeName", "mono.ryugu.v1.ImportTrackerResponse");
_define_property(ImportTrackerResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "body",
            kind: "message",
            T: ImportTrackerResponse$1
        }
    ]));
